import { GetUserNameTecnico, b64toBlob, coordenadasPoligono, coordenadasSelected, del, entidadeUser, get, getCheckedAdaptacao, getCheckedDefesa, getCheckedDefesaAdaptacao, getCheckedRetirada, getEaRegistoAnalise, getFlatCoordinatesApoioEA, getFlatCoordinatesEA, getValidateGeomEA, handleGenericError, hasPermission, isTabSelection, ocEstados, post, preventPropsNullValues, put, setCheckedAdaptacao, setCheckedDefesa, setCheckedDefesaAdaptacao, setCheckedRetirada, setCoordenadasPoligono, setCoordenadasSelected, setEaRegistoAnalise, setEaResultado, setFlatCordinatesApoioEA, setFlatCordinatesEA, setOcorrenciaSelected, setTabSelection, setValidateGeomEA } from '../../services/utils';
import styles from '../../styles/estrategiaAdaptacao/EstrategiaAdaptacao.module.scss'
import {
    MouseEvent as ReactMouseEvent,
    useCallback,
    useEffect,
    useLayoutEffect,
    useState,
    useRef
} from 'react'
import {
    Field,
    Form,
    FormElement,
    FormRenderProps,
} from '@progress/kendo-react-form'
import { AUTH_LOCALSTORAGE, DELETE_ANALISE, EA_POINT_NAME, GET_ANALISE, IMPORT_GEOM_EA_REGISTO_ANALISE, IMPORT_GEOM_EA_REGISTO_ABRANGENCIA, IS_GEOM_POLYGON_VALID, PERMISSION_ATUALIZAR_ESTRATEGIA_ADAPTACAO, PERMISSION_INSERIR_ESTRATEGIA_ADAPTACAO, RELATORIO_ESTRATEGIA_ADAPTACAO, REMOVER_AREA_APOIO_ESTRATEGIA_ADAPTACAO, REMOVER_AREA_PRINCIPAL_ESTRATEGIA_ADAPTACAO, SAVE_ANALISE, UPDATE_ANALISE, URL_AJUDA_ESTRATEGIA_ADAPTACAO, GET_EA_VALOR_USO_DE_SOLO_BY_CUSTOM_FILTERS, EA_ACAO_CHANGE_STATE, CONSULTAR_EA_ACAO, CURRENT_TIMEZONE, PESQUISAR_ENTIDADEBYUSER, RELATORIO_EA, OPERATIONAL_LAYER, LAYER_INDEX_REGISTO_ANALISE, LAYER_INDEX_REGISTO_ANALISE_APOIO, fs1Ano, fs2Ano, PERMISSION_ESTRATEGIA_ADAPTACAO_PERFIL_COMPLETO_EDICAO, PERMISSION_ESTRATEGIA_ADAPTACAO_PERFIL_INTERMEDIO_EDICAO, PERMISSION_ESTRATEGIA_ADAPTACAO_PERFIL_TOTAL } from '../../utils/constants';
import { Button, DropDownButton } from '@progress/kendo-react-buttons';
import { Dialog } from '@progress/kendo-react-dialogs'
import { TabStrip, TabStripSelectEventArguments, TabStripTab } from '@progress/kendo-react-layout';
import UsoDeSoloForm from '../usosdosolo/ValorUsoDoSoloForm'
import SessionStorageService from '../../services/SessionStorageService';
import IdentificacaoEstrategiaAdaptacao from './componentes/IdentificacaoEstrategiaAdaptacao';
import VusEstrategiaAdaptacao from './componentes/VusEstrategiaAdaptacao';
import AcaoEstrategiaAdaptacao from './componentes/AcaoEstrategiaAdaptacao';
import AnaliseEstrategiaAdaptacao from './componentes/AnaliseEstrategiaAdaptacao';
import EstrategiaAdaptacaoParametros from './Parametros';
import { useEstrategiaAdaptacaoStore } from '../../stores/estrategiaAdaptacao';
import { DocumentoListagem } from '../documentos/registar/documento/documento';
import ImportarGeometriaComponent from '../apoiogestao/registar/ImportarGeometriaForm';
import VisualizadorColunas from '../Generico/VisualizadorColunas ';
import { elementoClickMais, itemRenderMais, mostraFloatingMenu_e_Mapa, ocultaFloatingMenu_e_Mapa, telaMobile } from '../common/ItemRenderMais';
import html2canvas from 'html2canvas';
import ReactGA from 'react-ga4';
import moment from 'moment';
import { Checkbox, Switch } from '@progress/kendo-react-inputs';
import { Tooltip } from '@progress/kendo-react-tooltip';
import { textAlign } from 'html2canvas/dist/types/css/property-descriptors/text-align';

type Props = {
    onCloseClick: (
        e: ReactMouseEvent<HTMLButtonElement, MouseEvent>
    ) => void | undefined
}


interface DataVusForm {
    updated: boolean,
    vus: any[],
    valorTotalFS50Anos?: number,
    valorTotalFS100Anos?: number,
    anoReferencia?: string,
    [key: string]: any
}

interface DataAcoaForm {
    updated: boolean,
    anoReferencia: string,
    acoes: any[],
    acoesAtivas: any[],
    tendencia?: { slope: number, intercept: number },
    tendenciaRaw?: { slope: number, intercept: number },
    xyAcumulados?: { x: number; y: number }[],
    [key: string]: any
}

interface DataAnaliseForm {
    updatedVus: boolean,
    updatedAcao: boolean,
    dataRelatorio: string,
    cod_salvaguarda_faixa: any,
    retirada: boolean,
    adaptacao: boolean,
    defesa: boolean,
    defesa_adaptacao: boolean,
    custo_adaptacao_edificio: number,
    custo_demolicao: number,
    custo_renaturalizacao: number,
    vus?: any[],
    valorTotalFS50Anos?: number,
    valorTotalFS100Anos?: number,
    anoReferencia: string,
    acoesAtivas: any[],
    tendencia?: { slope: number, intercept: number },
    tendenciaRaw?: { slope: number, intercept: number },
    xyAcumulados?: { x: number; y: number }[],
    [key: string]: any,
    valorTotalAcao: number
}


export default function RegistarEstrategiaAdaptacaoTabs({ onCloseClick }: Props) {

    const MILHAO_CONVERTER = 1_000_000;

    const identificacaoFormRef = useRef<any>(null);
    const parametrosFormRef = useRef<any>(null);
    const vusFormRef = useRef<any>(null);
    const acaoFormRef = useRef<any>(null);

    const mountInitialTabsRef = useRef<number[]>([0, 1]);
    const timeOutMountRef = useRef<any>(null);
    const initializeTabs = useRef<boolean>(false);

    const [isMobile, setIsMobile] = useState(false);
    const [editMode, setEditMode] = useState(false);
    const [viewMode, setViewMode] = useState(false);
    const [openModalDescartar, setOpenModalDescartar] = useState<any>()
    const [deleteClicked, setDeleteClicked] = useState(false);
    const [selected, setSelected] = useState<number>(0)
    const [activeExportFicha, setActiveExportFicha] = useState<boolean>(false)
    const [realizeNovaAnalise, setRealizeNovaAnalise] = useState(false);

    const [optionsArea, setOptionsArea] = useState([
        {
            key: 'SiarlEditarGeometria',
            text: 'Editar área análise',
            disabled: false
        },
        {
            key: 'removerArea',
            text: 'Remover área análise',
            disabled: false
        },
        {
            key: 'ImportGeom',
            text: 'Importar Geom análise',
            disabled: false
        },
        {
            key: 'SiarlEditarGeometriaAbra',
            text: 'Editar área abrangência',
            disabled: false
        },
        {
            key: 'removerAreaAbra',
            text: 'Remover área abrangência',
            disabled: false
        },
        {
            key: 'ImportGeomAbra',
            text: 'Importar Geom abrangência',
            disabled: false
        }
    ]);

    const [removerAreaAbra, setRemoverAreaAbra] = useState(false);

    const [tituloAnalise, setTituloAnalise] = useState(false);
    const [disabledPolignoApoio, setDisabledPolignoApoio] = useState(false);
    const [openRemoveAreaModal, setOpenRemoveAreaModal] = useState<any>()
    const [openImportModal, setOpenImportModal] = useState<any>()

    const [registoAnalise, setRegistoAnalise] = useState<any>();
    const [valoresUsoDoSolo, setValoresUsoDoSolo] = useState<any>();
    const [acoes, setAcoes] = useState<any>();

    const [dataAcaoForm, setDataAcaoForm] = useState<DataAcoaForm>({
        updated: false,
        anoReferencia: '----',
        acoes: [],
        acoesAtivas: []
    });

    const [dataVusForm, setDataVusForm] = useState<DataVusForm>({
        updated: false,
        vus: [],
        valorTotalFS50Anos: 0,
        valorTotalFS100Anos: 0,
        anoReferencia: '----'
    });

    const [dataAnaliseForm, setDataAnaliseForm] = useState<DataAnaliseForm>({
        updatedVus: false,
        updatedAcao: false,
        dataRelatorio: "",
        retirada: false,
        adaptacao: false,
        defesa: false,
        cod_salvaguarda_faixa: {},
        defesa_adaptacao: false,
        custo_adaptacao_edificio: 0,
        custo_demolicao: 0,
        custo_renaturalizacao: 0,
        vus: [],
        valorTotalFS50Anos: 0,
        valorTotalFS100Anos: 0,
        anoReferencia: '----',
        acoesAtivas: [],
        valorTotalAcao: 0
    });

    // forms keys
    const [vusKey, setVusKey] = useState<number>(0);
    const [acaoKey, setAcaoKey] = useState<number>(0);
    const [analiseKey, setAnaliseKey] = useState<number>(0);

    // Is valid forms
    const [isValidIdentificacaoForm, setIsValidIdentificacaoForm] = useState(false);
    const [isValidParametrosForm, setIsValidParametrosForm] = useState(false);
    const [isValidVusForm, setIsValidVusForm] = useState(false);
    const [isValidAcaoForm, setIsValidAcaoForm] = useState(false);


    const [activeImportGeom, setActiveImportGeom] = useState();




    const relatorioEA = async (data: any) => await post<any, any>(`${RELATORIO_EA}`, data)

    const getAnalise = async (data: any) => await get<any, any>(`${GET_ANALISE}/` + data)

    const saveAnalise = async (data: any) => await post<any, any>(`${SAVE_ANALISE}`, data)

    const updateAnalise = async (data: any) => await put<any, any>(`${UPDATE_ANALISE}`, data)

    const deleteAnalise = (id: number) => del(`${DELETE_ANALISE}/${id}`, {})

    const importGeomEaRegistoAnalise = async (data: any) => await post<any, any>(`${IMPORT_GEOM_EA_REGISTO_ANALISE}`, data)

    const importGeomAbraEaRegistoAnalise = async (data: any) => await post<any, any>(`${IMPORT_GEOM_EA_REGISTO_ABRANGENCIA}`, data)

    const getEntidadeByUser = async (data: any) => await get<any, any>(`${PESQUISAR_ENTIDADEBYUSER}/` + data)

    const TOTAL_TABS = 5
    const ANALISE_TAB = 4
    const TAB_IDENTIFICACAO = 0;

    const CanUpdateEA = 
    hasPermission(PERMISSION_ESTRATEGIA_ADAPTACAO_PERFIL_INTERMEDIO_EDICAO) ||
    hasPermission(PERMISSION_ESTRATEGIA_ADAPTACAO_PERFIL_COMPLETO_EDICAO) ||
    hasPermission(PERMISSION_ESTRATEGIA_ADAPTACAO_PERFIL_TOTAL);

    useEffect(() => {
        if (viewMode) {
            sessionStorage.removeItem("novaAnaliseEstrategiaAdaptacao");
        }
    }, [])

    useEffect(() => {
        const registo = getEaRegistoAnalise();
        if (getEaRegistoAnalise()?.id) {
            setRegistoAnalise(getEaRegistoAnalise());
        } else {
            const utilizador_name = JSON.parse(localStorage.getItem(AUTH_LOCALSTORAGE) ?? '{}')?.user?.name;
            const utilizador_id = JSON.parse(localStorage.getItem(AUTH_LOCALSTORAGE) ?? '{}')?.user?.id;
      
            getEntidadeByUser(utilizador_id).then(resultEntidade => {
            setRegistoAnalise({ utilizador_id : utilizador_name, entidade_registo : resultEntidade?.nome  });

              });
        }
    }, []);
    useEffect(() => {
        ReactGA.send({ hitType: "pageview", page: "/RegistarEstrategiaAdaptacaoTabs" });
    }, []);

    useEffect(() => {
        setViewMode(!editMode && sessionStorage.getItem("novaAnaliseEstrategiaAdaptacao") != 'true');
    }, [])


    // draw the geometries of the loaded analysis on the map
    useEffect(() => {
        const iframe: any = document.getElementById('iframeGeoPortal')
        const idToSend = [selectedEstrategiaResult?.id];
        iframe.contentWindow?.postMessage(
            { type: 'SiarlEaRegistoAnaliseSearch', value: idToSend },
            '*'
        )

        const idAbrangencia = selectedEstrategiaResult?.eaAbrangencia?.id ?? undefined;
        if (idAbrangencia) {
            iframe.contentWindow?.postMessage(
                { type: 'SiarlEaAnaliseAbrangenciaSearch', value: [idAbrangencia] },
                '*'
            )
        }
    }, [])

    useEffect(() => {
        setOptionsArea(optionsArea.map((option) => {
            switch (option.key) {
                case "SiarlEditarGeometria":
                case "removerArea":
                    option.disabled = !registoAnalise?.flatCoordinates || registoAnalise?.flatCoordinates?.trim() == "" || selected != TAB_IDENTIFICACAO
                    break;
                case "SiarlEditarGeometriaAbra":
                case "removerAreaAbra":
                    option.disabled = !registoAnalise?.flatCoordinatesApoio || registoAnalise?.flatCoordinatesApoio?.trim() == "" || selected != TAB_IDENTIFICACAO
                    break;
                case "ImportGeomAbra":
                    option.disabled = !registoAnalise?.flatCoordinates || registoAnalise?.flatCoordinates?.trim() == "" || selected != TAB_IDENTIFICACAO
                    break;
                case "ImportGeom":
                    option.disabled = selected != TAB_IDENTIFICACAO
                    break;
                default:
                    break;
            }
            return option;
        }));
    }, [registoAnalise, selected])


    useEffect(() => {
        setActiveExportFicha(selected == ANALISE_TAB);
        afterTabSelecetd();
    }, [selected])

    const afterTabSelecetd = async () => {

        const isDirty = isDirtyConfigData();

        let myDataVusForm = { ...dataVusForm };
        let myDataAcaoForm = { ...dataAcaoForm };

        if (isDirty) {
            identificacaoFormRef.current.freezerValues()

            if (parametrosFormRef.current) {
                parametrosFormRef.current.freezerValues()
            }

            myDataVusForm = { updated: false, vus: [] };
            myDataAcaoForm = { updated: false, anoReferencia: '----', acoes: [], acoesAtivas: [] };

            setDataVusForm(myDataVusForm);
            setDataAcaoForm(myDataAcaoForm);

            if (!viewMode) {
                await handleSubmit(null);
            }
        }

        switch (selected) {
            case 2:
                if (isDirty || !dataVusForm.updated) {
                    await loadVus(true);
                }
                break;
            case 3:
                if (isDirty || !dataAcaoForm.updated) {
                    await loadAcao(true);
                }
                break;
            case 4:
                if (isDirty || !dataVusForm.updated || !dataAcaoForm.updated) {
                    await loadAnalise(myDataVusForm, myDataAcaoForm);
                }
                break;
            default:
                break;
        }
    };


    const registerInitializeForm = async (idForm: number) => {

        if (timeOutMountRef.current) {
            const index = mountInitialTabsRef.current.findIndex((initialTab) => initialTab == idForm);

            if (index > -1) {
                mountInitialTabsRef.current = mountInitialTabsRef.current.slice(1);

                if (mountInitialTabsRef.current.length == 0) {
                    initializeTabs.current = true;
                    setSelected(0);
                    postMessage({ type: "hideLoader" }, "*");
                    clearInterval(timeOutMountRef.current);
                    timeOutMountRef.current = null;

                    await loadAnalise();
                }
            }
        } else {
            postMessage({ type: "hideLoader" }, "*");
        }
    }

    const activeInitialTab = () => {
        postMessage({ type: "showLoader" }, "*");

        if (mountInitialTabsRef.current.length > 0) {
            if (selected != mountInitialTabsRef.current[0]) {
                setSelected(mountInitialTabsRef.current[0]);
            }
        }
    }

    if (!initializeTabs.current && getEaRegistoAnalise()?.id && !timeOutMountRef.current) {
        timeOutMountRef.current = setInterval(activeInitialTab, 1000);
    } else {
        initializeTabs.current = true;
    }


    /**
     * Function to update the analysis area or the abrangencia area
     * @param infoArea
     */
    const updateArea = async (infoArea: any) => {

        let callGP;
        let eaRegistoAnaliseSaved;

        postMessage({ type: "showLoader" }, "*");


        if ("flatCoordinates" in infoArea || "flatCoordinatesApoio" in infoArea) {

            const sendData = updateSendData();

            if (sendData?.id) {
                eaRegistoAnaliseSaved = await updateAnalise({ ...sendData, ...infoArea });
            }
            else {
                eaRegistoAnaliseSaved = await saveAnalise({ ...sendData, ...infoArea });
            }

            restartDataForms();

            selectEstrategiaResult(eaRegistoAnaliseSaved)
            setEaRegistoAnalise(eaRegistoAnaliseSaved);
            setRegistoAnalise(eaRegistoAnaliseSaved);

            if ("flatCoordinates" in infoArea) {
                callGP = {
                    type: 'SiarlEaRegistoAnaliseSearch',
                    value: [eaRegistoAnaliseSaved?.id]
                };

                setValidateGeomEA(true);
                saveScreenById("poligonoAnalise");
            }

            if ("flatCoordinatesApoio" in infoArea) {
                if (eaRegistoAnaliseSaved?.eaAbrangencia?.id) {

                    callGP = {
                        type: 'SiarlEaAnaliseAbrangenciaSearch',
                        value: [eaRegistoAnaliseSaved?.eaAbrangencia?.id]
                    };
                    saveScreenById("poligonoAbrangencia");
                }
            }
        }

        postMessage({ type: "hideLoader" }, "*");

        if (callGP) {
            const iframe: any = document.getElementById('iframeGeoPortal')
            iframe.contentWindow?.postMessage(callGP, '*');

            const cleanMap = { ids: [], result: [], active: false };

            iframe.contentWindow?.postMessage({ type: 'SiarlUsVusPoligonoSearch', value: cleanMap }, '*');

            iframe.contentWindow?.postMessage({ type: 'SiarlUsVusPontoSearch', value: cleanMap }, '*');

            iframe.contentWindow?.postMessage({ type: "SiarlIntAcaoSearch", value: cleanMap }, '*');
        }
    };

    const saveScreenById = async (key: "poligonoAbrangencia" | "poligonoAnalise") => {
        let mapImage = ''

        if (!window.location.href.includes('localhost')) {
            const mapIframe = document.querySelector(
                '#iframeGeoPortal'
            ) as HTMLIFrameElement

            const mapIframeInnerContent =
                mapIframe.contentWindow?.document.querySelector(
                    'section.content'
                ) as HTMLElement

            const generatedImage = await html2canvas(mapIframeInnerContent)
            mapImage = generatedImage.toDataURL()
            if (key === "poligonoAbrangencia") {
                SessionStorageService.setItem(key, JSON.stringify({
                    img_mapa_area_abrangencia: mapImage
                }))
            } if (key === "poligonoAnalise") {
                SessionStorageService.setItem(key, JSON.stringify({
                    img_mapa: mapImage
                }))
            }
        }
    }


    const selectedEstrategiaResult: any = useEstrategiaAdaptacaoStore(
        (state) => state.selectedEstrategiaResult
    )

    const selectedEstrategiaResultId = useEstrategiaAdaptacaoStore(
        (state) => state.selectedEstrategiaResultId
    )

    const selectEstrategiaResultId = useEstrategiaAdaptacaoStore(
        (state) => state.selectEstrategiaResultId
    )

    const selectEstrategiaResult = useEstrategiaAdaptacaoStore(
        (state) => state.selectEstrategiaResult
    )

    const optionsEditar = [
        {
            key: 'SiarlEditar',
            text: 'Editar'
        },
        {
            key: 'SiarlApagar',
            text: 'Apagar'
        }
    ]

    const onEditItemClick = (event: any) => {
        if (event == "SiarlEditar" || event?.item?.key == "SiarlEditar") {
            setEditMode(true);
            setViewMode(false);
            handleAlteraTitulo();
            sessionStorage.setItem('novaAnaliseEstrategiaAdaptacao', 'false')
            return;
        }
        if (event == "SiarlVisualizar") {
            setEditMode(false);
            setViewMode(true);
            sessionStorage.setItem('novaAnaliseEstrategiaAdaptacao', 'false')
        }
        if (event?.item?.key == "SiarlApagar") {
            setDeleteClicked(true);
            setOpenModalDescartar(true);
        }
    }

    /**
     * items DropDown menu
     * @param props
     */
    const itemRender = (props: { item: any; itemIndex: number }) => {

        const isTitleItem = props.item.key === 'titulo';
        const style = props.item.disabled ? { pointerEvents: 'none' as const, opacity: 0.5 } : {}

        if (isTitleItem) {
            // Item de título personalizado
            return (
                <div className={styles.DropDownButtonTitulo} style={style}>
                    <span>{props.item.text}</span>
                </div>
            );
        } else {
            // Demais itens
            return (
                <div className={styles.DropDownButtonItem} style={style}>
                    <span>{props.item.text}</span>
                </div>
            );
        }
    };

    const onClickOpenFileDoc = async () => {
        // TO DO OpenFileDoc
    }

    const onDropDowAreaItemClick = (event: any) => {
        switch (event?.item?.key) {
            case "SiarlEditarGeometria":
                identificacaoFormRef.current.drawAreaAnalisis();
                break;
            case "SiarlEditarGeometriaAbra":
                identificacaoFormRef.current.drawAreaApoio();
                break;
            case "ImportGeom":
            case "ImportGeomAbra":
                setActiveImportGeom(event?.item?.key);
                // show modal to import geometry
                setOpenImportModal(true);
                break;
            case "removerArea":
                setRemoverAreaAbra(false);
                setOpenRemoveAreaModal(true);
                break;
            case "removerAreaAbra":
                setRemoverAreaAbra(true);
                setOpenRemoveAreaModal(true);
                break;
            default:
        }
        /*if (event?.item?.key == ) {

        } else {
            selectMapAction(event.item)
        }*/
    }

    const selectMapAction = (item: any) => {
        const iframe: any = document.getElementById('iframeGeoPortal')

        if (item.key == "removerArea") {
            setOpenRemoveAreaModal(true)
        } else {
            iframe.contentWindow?.postMessage({ type: item.key, value: getEaRegistoAnalise()?.id, editGpLayer: EA_POINT_NAME }, '*')
        }
    }

    /**
     * Remover areas
     * @param isAreaAbra
     */
    const removeArea = async () => {

        setOpenRemoveAreaModal(false);

        postMessage({ type: "showLoader" }, "*");

        try {
            const result = await identificacaoFormRef.current.removeArea(removerAreaAbra);

            try {
                if (result) {
                    // load data registo analise with geom field updated
                    await loadRegistoAnalise("Geometria removida, Não é possivel mostrar os dados neste momento");
                }
            } catch (e) {
                if (!result) {
                    postMessage({ type: "errorMsg", value: "Geometria não removida" }, "*");
                }
            }
        } catch (e) {
            postMessage({ type: "errorMsg", value: "Registo salvo mas, Não é possivel mostrar os dados neste momento" }, "*");
        } finally {
            setRemoverAreaAbra(false);
            postMessage({ type: "hideLoader" }, "*");
        }
        await refreshForm(getEaRegistoAnalise()?.id)
        // setOpenRemoveAreaModal(false)
    }

    const listVus = [
        { id: 1, descricao: "MarkRisk Edifícios (polígono)" },
        { id: 2, descricao: "Universidade Nova (ponto)" },
        { id: 3, descricao: "Carta de ocupação do Solo" },
        { id: 4, descricao: "Serviço de ecossistemas" },
    ];

    const listFaixaSalvaguarda = [
        { id: 1, descricao: "Faixa de salvaguarda à erosão costeira - Nível 1" },
        { id: 2, descricao: "Faixa de salvaguarda à erosão costeira - Nível 2" },
        { id: 0, descricao: "Faixa de salvaguarda ao galgamento e inundação costeira - Nível 1" },
        { id: 4, descricao: "Faixa de salvaguarda ao galgamento e inundação costeira - Nível 2" },
    ];

    const onItemClickImprimir = async (event: any) => {

        if (!activeExportFicha) {
            postMessage({type:"infoMsg", value: {message: "Navegue até ao tabulador análise para imprimir/exportar"}})
            return false        
        }

        const objToSendImgMapa: any = {
            CodPrintTemplate: "RELATORIO_EA",
            extendInfo: {
                spatialReference: {
                    wkid: 0
                },
                xmin: 0,
                ymin: 0,
                xmax: 0,
                ymax: 0
            },
            ListOperationalLayerInfo: [
                {
                    IdOperationLayer: OPERATIONAL_LAYER,
                    UseLayerExtent: false,
                    DefinitionExpression: "",
                    ListServiceLayer: [
                        {
                            LayerId: LAYER_INDEX_REGISTO_ANALISE,
                            DefinitionExpression: "id=" + selectedEstrategiaResult?.id,
                            UseLayerExtent: selectedEstrategiaResult?.hasGeomAbrangencia ? false : true
                        },
                        {
                            LayerId: LAYER_INDEX_REGISTO_ANALISE_APOIO,
                            DefinitionExpression: "analise_id=" + selectedEstrategiaResult?.id,
                            UseLayerExtent: selectedEstrategiaResult?.hasGeomAbrangencia ? true : false
                        }
                    ]
                }
            ]
        }

        const chartCanvasAcao = document.querySelector('#graficoAcao') as HTMLCanvasElement;
        let chartImageAcao;
        if (chartCanvasAcao) {
            const generatedChartImage = await html2canvas(chartCanvasAcao);
            chartImageAcao = generatedChartImage.toDataURL();
        }

        const chartCanvasAnalise = document.querySelector('#graficoAnalise') as HTMLCanvasElement;
        let chartImageAnalise;
        if (chartCanvasAnalise) {
            const generatedChartImage = await html2canvas(chartCanvasAnalise);
            chartImageAnalise = generatedChartImage.toDataURL();
        }

        // const chartCanvasCabecalhoAnalise = document.querySelector('#cabeçalhografico') as HTMLCanvasElement;
        // let chartImageCabecalhoAnalise;
        // if (chartCanvasAnalise) {
        //     const generatedChartImage = await html2canvas(chartCanvasCabecalhoAnalise);
        //     chartImageCabecalhoAnalise = generatedChartImage.toDataURL();
        // }

       
        const agrupados: any = {};

        if (Array.isArray(dataVusForm.vus)) {
            for (const item of dataVusForm.vus) {
            const descricao = item.usVus && item.usVus.descricao ? item.usVus.descricao : '-';
            const tipoComponente = item.usTipoComponenteVus && item.usTipoComponenteVus.descricao ? item.usTipoComponenteVus.descricao : '-';
            const anoVus = item.usVus && item.usVus.ano_vus ? item.usVus.ano_vus : '-';
            const nivelFaixa = item.nivel_faixa ? item.nivel_faixa : '-';
            const taxa = parseFloat((item.taxa ?? 0));
            const valorAtualizado = parseFloat((item.valor ?? 0).toFixed(2));

            const chaveAgrupamento = `${descricao}-${tipoComponente}-${anoVus}-${nivelFaixa}`;

            if (!agrupados[chaveAgrupamento]) {
                agrupados[chaveAgrupamento] = {
                    'Nome VUS': descricao,
                    'Tipo componente': tipoComponente,
                    'Ano componente': anoVus,
                    'Nivel faixa': nivelFaixa,
                    'Taxa': taxa,
                    'Valor atualizado': valorAtualizado,
                };
            } else {
                agrupados[chaveAgrupamento]['Valor atualizado'] += valorAtualizado;
            }
    }

    for (const key in agrupados) {
        agrupados[key]['Valor atualizado'] = new Intl.NumberFormat('pt-PT', { 
            style: 'currency', 
            currency: 'EUR', 
            minimumFractionDigits: 2 
        }).format(agrupados[key]['Valor atualizado']).replace(/\s/g, ' ');
    }
}

        const formattedValorTotalAcao = `${new Intl.NumberFormat('pt-PT', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(dataAnaliseForm.valorTotalAcao)} €`;


        const formattedVus = Object.values(agrupados);

        const formattedAcoes = Array.isArray(dataAnaliseForm.acoesAtivas)
        ? dataAnaliseForm.acoesAtivas.map((item: any) => ({
            'ID': item.id_acao ?? '-',
            'Designacao': item.designacao ?? '-', 
            'Tipo n4': item.tipo_n4?.descricao ?? '-', 
            'Data conclusao': item.data_con_e
            ? new Date(item.data_con_e).toLocaleDateString('pt-PT', { day: '2-digit', month: '2-digit', year: 'numeric' }) 
            : '-',           
             'Taxa': item.taxa ?? '-',
            'Valor atualizado': item.valor
            ? `${new Intl.NumberFormat('pt-PT', { style: 'currency', currency: 'EUR', minimumFractionDigits: 2 }).format(item.valor).replace(/\s/g, ' ')}`
            : '-',
        }))
        : [];

        try {

             postMessage({ type: 'showLoader' }, '*')
             
            //Definição de área de análise
            let area_analise
            if (selectedEstrategiaResult?.hasGeom == true) {
                area_analise = "• Polígono da área de análise\n"
            }
            if (selectedEstrategiaResult?.hasGeomAbrangencia == true) {
                area_analise = area_analise + "• Polígono da área de abragência"
            }


            //Componentes de análise
            const retirada = selectedEstrategiaResult?.retirada ? "Retirada" : "";
            const defesa = selectedEstrategiaResult?.defesa ? "Defesa" : "";
            const adaptacao = selectedEstrategiaResult?.adaptacao ? "Adaptacao" : "";
            const defesa_adaptacao = selectedEstrategiaResult?.defesa_adaptacao ? "Defesa + adaptação" : "";

            const componente_analise = [retirada, defesa, adaptacao, defesa_adaptacao]
                .filter(Boolean)
                .join("; ");


            // Período de análise
            let data_de_analise: any;

            if (selectedEstrategiaResult?.dt_periodo_analise_de) {
                data_de_analise = "De " + new Date(selectedEstrategiaResult.dt_periodo_analise_de).toLocaleDateString() + " a ";
            }

            if (selectedEstrategiaResult?.dt_periodo_analise_para) {
                data_de_analise += new Date(selectedEstrategiaResult.dt_periodo_analise_para).toLocaleDateString();
            }


            //Atualização de preços
            let atualizacao_preco: any;
            if (selectedEstrategiaResult?.atualizacao_preco == 0) {
                atualizacao_preco = "Preços atuais (IPC)"
            }
            else if (selectedEstrategiaResult?.atualizacao_preco == 1) {
                atualizacao_preco = "Preço por índice manual " + selectedEstrategiaResult?.atualizacao_preco_valor
            }
            else if (selectedEstrategiaResult?.atualizacao_preco == 2) {
                atualizacao_preco = "Preço para ano de referência (IPC) " + selectedEstrategiaResult?.atualizacao_preco_ano
            }
            else if (selectedEstrategiaResult?.atualizacao_preco == 3) {
                atualizacao_preco = "Sem atualização de preços"
            }



            //faixas de salvaguarda:
            const faixaSalvaguarda_descriptions = selectedEstrategiaResult?.salvaguarda_faixa?.map((faixaId: number) => {
                const faixa = listFaixaSalvaguarda.find((item) => item.id === faixaId);
                return faixa ? `• ${faixa.descricao}` : "• Descrição não encontrada";
            }).join("\n");

            //VUS
            const vus_descriptions = selectedEstrategiaResult?.vus?.map((vusId: number) => {
                const vu = listVus.find((item) => item.id === vusId);
                return vu ? `• ${vu.descricao}` : "";
            }).join("\n");

               //ultima tabela

            

            const lstGridAnalise = SessionStorageService.getItem("dataAnaliseDados");
            const dataRelatorio = new Date(SessionStorageService.getItem("dataRelatorio"));
            const anoRelatorio = dataRelatorio.getFullYear();
            
            const formatCurrency = (value : any) => {
                return value ? `${value.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$& ').replace('.', ',')} €` : '0€';
            };
          

            const formattedlstAnalise = {
                'Retirada1': formatCurrency(lstGridAnalise.vusFS1),
                'Retirada2': formatCurrency(lstGridAnalise.vusFS2),
                'AdaptacaoAnoAtual': `${formatCurrency(0)}`,
                'Adaptacao1': ` ${formatCurrency(lstGridAnalise.custoAdaptacao50)}`,
                'Adaptacao2': ` ${formatCurrency(lstGridAnalise.custoAdaptacao100)}`,
                'DefesaAnoAtual': `${formatCurrency(lstGridAnalise.custoDefesaAnoActual)}`,
                'Defesa1': ` ${formatCurrency(lstGridAnalise.custoDefesa50)}`,
                'Defesa2': ` ${formatCurrency(lstGridAnalise.custoDefesa100)}`,
                'DefesaAdaptacaoAnoAtual': `${formatCurrency(lstGridAnalise.custoDefesaAnoActual)}`,
                'DefesaAdaptacao1': `${formatCurrency(lstGridAnalise.custoDefesaAdaptacao50)}`,
                'DefesaAdaptacao2': `${formatCurrency(lstGridAnalise.custoDefesaAdaptacao100)}`,
                'AnoRelatorio': anoRelatorio ?? ''
            };

            const ResultEntidade = await getEntidadeByUser(selectedEstrategiaResult?.utilizador?.id)

            const documentoBase64 = await relatorioEA({
                id: selectedEstrategiaResult?.id,
                dados: {
                    //REGISTO
                    'Data do registo': selectedEstrategiaResult?.data_registo ? new Date(selectedEstrategiaResult?.data_registo).toLocaleDateString() : '',
                    'Técnico': selectedEstrategiaResult?.utilizador?.userName ?? '',
                    'Entidade': ResultEntidade?.nome ?? '',

                    //IDENTIFICACAO
                    'Data do relatorio': selectedEstrategiaResult?.data_hora_relatorio ? new Date(selectedEstrategiaResult?.data_hora_relatorio).toLocaleDateString() : 'Data indeterminada',
                    'Titulo': selectedEstrategiaResult?.titulo ?? '',

                    'Area analise': area_analise ?? '',

                    //LOCALIZACAO
                    'Concelho': selectedEstrategiaResult?.concelhos?.length > 0 ? selectedEstrategiaResult.concelhos[0].nome : '',
                    'ARH': selectedEstrategiaResult?.arhs?.length > 0 ? selectedEstrategiaResult.arhs[0].nome : '',
                    'Capitania': selectedEstrategiaResult?.capitanias?.length > 0 ? selectedEstrategiaResult.capitanias[0].nome : '',

                    //PARAMETROS
                    'Componentes da analise': componente_analise ?? '',
                    'Periodo de analise': data_de_analise ?? '',
                    'Custo de adaptacao': (selectedEstrategiaResult?.custo_adaptacao_edificio ? selectedEstrategiaResult.custo_adaptacao_edificio + '€/m²' : ''),
                    'Custo de demolicao': (selectedEstrategiaResult?.custo_demolicao ? selectedEstrategiaResult.custo_demolicao + '€/m²' : ''),
                    'Custo de renaturalizacao': (selectedEstrategiaResult?.custo_renaturalizacao ? selectedEstrategiaResult.custo_renaturalizacao + '€/m²' : ''),
                    'Atualizacao de precos': atualizacao_preco ?? '',
                    'Tipologia n4': selectedEstrategiaResult?.lstTipologiasObra ?? '• Todas (sem seleção do utilizador)',
                    'Total faixa 1': dataVusForm?.valorTotalFS50Anos
                        ? `${new Intl.NumberFormat('pt-PT', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(dataVusForm.valorTotalFS50Anos)} €`
                        : '',
                    'Total faixa 2': dataVusForm?.valorTotalFS100Anos
                        ? `${new Intl.NumberFormat('pt-PT', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(dataVusForm.valorTotalFS100Anos)} €`
                        : '',
                    'Valor total acoes': formattedValorTotalAcao ?? '',

                    'Faixas de salvaguarda': faixaSalvaguarda_descriptions ?? '',
                    'VUS': vus_descriptions ?? '',
                    'Adaptacao': selectedEstrategiaResult?.adaptacao ?? '',
                    'Retirada': selectedEstrategiaResult?.retirada ?? '',
                    'Defesa': selectedEstrategiaResult?.defesa ?? '',
                    'Defesa_adaptacao': selectedEstrategiaResult?.defesa_adaptacao ?? '',

                    formattedVus,
                    formattedAcoes,
                    formattedlstAnalise


                },
                img_mapa: "",//mapImage.replace("data:image/png;base64,", ""),
                objJsonToCreateImg: objToSendImgMapa,
                grafico_acoes: chartImageAcao,
                grafico_analise: chartImageAnalise,
                grafico_analise_cabecalho: ''
            });

            if (documentoBase64) {
                const blob = b64toBlob(documentoBase64, 'application/pdf');
                const blobUrl = URL.createObjectURL(blob);
                window.open(blobUrl, '_blank');
                postMessage({ type: 'hideLoader' }, '*')
            }
        } catch (error) {
            console.log({ error })
            postMessage({ type: 'errorMsg', value: { message: "Não foi possivel efetuar esta operação" } }, '*')

        } finally {
            postMessage({ type: 'hideLoader' }, '*')
        }
    }

    const onItemClickExportar = async (event: any) => {

        
        if (!activeExportFicha) {
            postMessage({type:"infoMsg", value: {message: "Navegue até ao tabulador análise para imprimir/exportar"}})
            return false        
        }

        const objToSendImgMapa: any = {
            CodPrintTemplate: "RELATORIO_EA",
            extendInfo: {
                spatialReference: {
                    wkid: 0
                },
                xmin: 0,
                ymin: 0,
                xmax: 0,
                ymax: 0
            },
            ListOperationalLayerInfo: [
                {
                    IdOperationLayer: OPERATIONAL_LAYER,
                    UseLayerExtent: false,
                    DefinitionExpression: "",
                    ListServiceLayer: [
                        {
                            LayerId: LAYER_INDEX_REGISTO_ANALISE,
                            DefinitionExpression: "id=" + selectedEstrategiaResult?.id,
                            UseLayerExtent: selectedEstrategiaResult?.hasGeomAbrangencia ? false : true
                        },
                        {
                            LayerId: LAYER_INDEX_REGISTO_ANALISE_APOIO,
                            DefinitionExpression: "analise_id=" + selectedEstrategiaResult?.id,
                            UseLayerExtent: selectedEstrategiaResult?.hasGeomAbrangencia ? true : false
                        }
                    ]
                }
            ]
        }

        const chartCanvasAcao = document.querySelector('#graficoAcao') as HTMLCanvasElement;
        let chartImageAcao;
        if (chartCanvasAcao) {
            const generatedChartImage = await html2canvas(chartCanvasAcao);
            chartImageAcao = generatedChartImage.toDataURL();
        }

        const chartCanvasAnalise = document.querySelector('#graficoAnalise') as HTMLCanvasElement;
        let chartImageAnalise;
        if (chartCanvasAnalise) {
            const generatedChartImage = await html2canvas(chartCanvasAnalise);
            chartImageAnalise = generatedChartImage.toDataURL();
        }

        // const chartCanvasCabecalhoAnalise = document.querySelector('#cabeçalhografico') as HTMLCanvasElement;
        // let chartImageCabecalhoAnalise;
        // if (chartCanvasAnalise) {
        //     const generatedChartImage = await html2canvas(chartCanvasCabecalhoAnalise);
        //     chartImageCabecalhoAnalise = generatedChartImage.toDataURL();
        // }
 
        const agrupados: any = {};

        if (Array.isArray(dataVusForm.vus)) {
            for (const item of dataVusForm.vus) {
            const descricao = item.usVus && item.usVus.descricao ? item.usVus.descricao : '-';
            const tipoComponente = item.usTipoComponenteVus && item.usTipoComponenteVus.descricao ? item.usTipoComponenteVus.descricao : '-';
            const anoVus = item.usVus && item.usVus.ano_vus ? item.usVus.ano_vus : '-';
            const nivelFaixa = item.nivel_faixa ? item.nivel_faixa : '-';
            const taxa = parseFloat((item.taxa ?? 0));
            const valorAtualizado = parseFloat((item.valor ?? 0).toFixed(2));

            const chaveAgrupamento = `${descricao}-${tipoComponente}-${anoVus}-${nivelFaixa}`;

            if (!agrupados[chaveAgrupamento]) {
                agrupados[chaveAgrupamento] = {
                    'Nome VUS': descricao,
                    'Tipo componente': tipoComponente,
                    'Ano componente': anoVus,
                    'Nivel faixa': nivelFaixa,
                    'Taxa': taxa,
                    'Valor atualizado': valorAtualizado,
                };
            } else {
                agrupados[chaveAgrupamento]['Valor atualizado'] += valorAtualizado;
            }
    }
        }

        const formattedValorTotalAcao = `${new Intl.NumberFormat('pt-PT', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(dataAnaliseForm.valorTotalAcao)} €`;


        const formattedVus = Object.values(agrupados);

        const formattedAcoes = Array.isArray(dataAnaliseForm.acoesAtivas)
        ? dataAnaliseForm.acoesAtivas.map((item: any) => ({
            'ID': item.id_acao ?? '-',
            'Designacao': item.designacao ?? '-', 
            'Tipo n4': item.tipo_n4?.descricao ?? '-', 
            'Data conclusao': item.data_con_e
            ? new Date(item.data_con_e).toLocaleDateString('pt-PT', { day: '2-digit', month: '2-digit', year: 'numeric' }) 
            : '-',           
             'Taxa': item.taxa ?? '-',
            'Valor atualizado': item.valor
            ? `${new Intl.NumberFormat('pt-PT', { style: 'currency', currency: 'EUR', minimumFractionDigits: 2 }).format(item.valor).replace(/\s/g, ' ')}`
            : '-',
        }))
        : [];

        try {

             postMessage({ type: 'showLoader' }, '*')
             
            //Definição de área de análise
            let area_analise
            if (selectedEstrategiaResult?.hasGeom == true) {
                area_analise = "• Polígono da área de análise\n"
            }
            if (selectedEstrategiaResult?.hasGeomAbrangencia == true) {
                area_analise = area_analise + "• Polígono da área de abragência"
            }


            //Componentes de análise
            const retirada = selectedEstrategiaResult?.retirada ? "Retirada" : "";
            const defesa = selectedEstrategiaResult?.defesa ? "Defesa" : "";
            const adaptacao = selectedEstrategiaResult?.adaptacao ? "Adaptacao" : "";
            const defesa_adaptacao = selectedEstrategiaResult?.defesa_adaptacao ? "Defesa + adaptação" : "";

            const componente_analise = [retirada, defesa, adaptacao, defesa_adaptacao]
                .filter(Boolean)
                .join("; ");


            // Período de análise
            let data_de_analise: any;

            if (selectedEstrategiaResult?.dt_periodo_analise_de) {
                data_de_analise = "De " + new Date(selectedEstrategiaResult.dt_periodo_analise_de).toLocaleDateString() + " a ";
            }

            if (selectedEstrategiaResult?.dt_periodo_analise_para) {
                data_de_analise += new Date(selectedEstrategiaResult.dt_periodo_analise_para).toLocaleDateString();
            }


            //Atualização de preços
            let atualizacao_preco: any;
            if (selectedEstrategiaResult?.atualizacao_preco == 0) {
                atualizacao_preco = "Preços atuais (IPC)"
            }
            else if (selectedEstrategiaResult?.atualizacao_preco == 1) {
                atualizacao_preco = "Preço por índice manual " + selectedEstrategiaResult?.atualizacao_preco_valor
            }
            else if (selectedEstrategiaResult?.atualizacao_preco == 2) {
                atualizacao_preco = "Preço para ano de referência (IPC) " + selectedEstrategiaResult?.atualizacao_preco_ano
            }
            else if (selectedEstrategiaResult?.atualizacao_preco == 3) {
                atualizacao_preco = "Sem atualização de preços"
            }



            //faixas de salvaguarda:
            const faixaSalvaguarda_descriptions = selectedEstrategiaResult?.salvaguarda_faixa?.map((faixaId: number) => {
                const faixa = listFaixaSalvaguarda.find((item) => item.id === faixaId);
                return faixa ? `• ${faixa.descricao}` : "• Descrição não encontrada";
            }).join("\n");

            //VUS
            const vus_descriptions = selectedEstrategiaResult?.vus?.map((vusId: number) => {
                const vu = listVus.find((item) => item.id === vusId);
                return vu ? `• ${vu.descricao}` : "";
            }).join("\n");

               //ultima tabela

            

            const lstGridAnalise = SessionStorageService.getItem("dataAnaliseDados");
            const dataRelatorio = new Date(SessionStorageService.getItem("dataRelatorio"));
            const anoRelatorio = dataRelatorio.getFullYear();
            
            const formatCurrency = (value : any) => {
                return value ? `${value.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$& ').replace('.', ',')} €` : '0€';
            };
        

            const formattedlstAnalise = {
                'Retirada1': formatCurrency(lstGridAnalise.vusFS1),
                'Retirada2': formatCurrency(lstGridAnalise.vusFS2),
                'AdaptacaoAnoAtual': `${formatCurrency(0)}`,
                'Adaptacao1': ` ${formatCurrency(lstGridAnalise.custoAdaptacao50)}`,
                'Adaptacao2': ` ${formatCurrency(lstGridAnalise.custoAdaptacao100)}`,
                'DefesaAnoAtual': `${formatCurrency(lstGridAnalise.custoDefesaAnoActual)}`,
                'Defesa1': ` ${formatCurrency(lstGridAnalise.custoDefesa50)}`,
                'Defesa2': ` ${formatCurrency(lstGridAnalise.custoDefesa100)}`,
                'DefesaAdaptacaoAnoAtual': `${formatCurrency(lstGridAnalise.custoDefesaAnoActual)}`,
                'DefesaAdaptacao1': `${formatCurrency(lstGridAnalise.custoDefesaAdaptacao50)}`,
                'DefesaAdaptacao2': `${formatCurrency(lstGridAnalise.custoDefesaAdaptacao100)}`,
                'AnoRelatorio': anoRelatorio ?? ''
            };

            const ResultEntidade = await getEntidadeByUser(selectedEstrategiaResult?.utilizador?.id)

            const documentoBase64 = await relatorioEA({
                id: selectedEstrategiaResult?.id,
                dados: {
                    //REGISTO
                    'Data do registo': selectedEstrategiaResult?.data_registo ? new Date(selectedEstrategiaResult?.data_registo).toLocaleDateString() : '',
                    'Técnico': selectedEstrategiaResult?.utilizador?.userName ?? '',
                    'Entidade': ResultEntidade?.nome ?? '',

                    //IDENTIFICACAO
                    'Data do relatorio': selectedEstrategiaResult?.data_hora_relatorio ? new Date(selectedEstrategiaResult?.data_hora_relatorio).toLocaleDateString() : 'Data indeterminada',
                    'Titulo': selectedEstrategiaResult?.titulo ?? '',

                    'Area analise': area_analise ?? '',

                    //LOCALIZACAO
                    'Concelho': selectedEstrategiaResult?.concelhos?.length > 0 ? selectedEstrategiaResult.concelhos[0].nome : '',
                    'ARH': selectedEstrategiaResult?.arhs?.length > 0 ? selectedEstrategiaResult.arhs[0].nome : '',
                    'Capitania': selectedEstrategiaResult?.capitanias?.length > 0 ? selectedEstrategiaResult.capitanias[0].nome : '',

                    //PARAMETROS
                    'Componentes da analise': componente_analise ?? '',
                    'Periodo de analise': data_de_analise ?? '',
                    'Custo de adaptacao': (selectedEstrategiaResult?.custo_adaptacao_edificio ? selectedEstrategiaResult.custo_adaptacao_edificio + '€/m²' : ''),
                    'Custo de demolicao': (selectedEstrategiaResult?.custo_demolicao ? selectedEstrategiaResult.custo_demolicao + '€/m²' : ''),
                    'Custo de renaturalizacao': (selectedEstrategiaResult?.custo_renaturalizacao ? selectedEstrategiaResult.custo_renaturalizacao + '€/m²' : ''),
                    'Atualizacao de precos': atualizacao_preco ?? '',
                    'Tipologia n4': selectedEstrategiaResult?.lstTipologiasObra ?? '• Todas (sem seleção do utilizador)',
                    'Total faixa 1': dataVusForm?.valorTotalFS50Anos
                        ? `${new Intl.NumberFormat('pt-PT', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(dataVusForm.valorTotalFS50Anos)} €`
                        : '',
                    'Total faixa 2': dataVusForm?.valorTotalFS100Anos
                        ? `${new Intl.NumberFormat('pt-PT', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(dataVusForm.valorTotalFS100Anos)} €`
                        : '',
                    'Valor total acoes': formattedValorTotalAcao ?? '',

                    'Faixas de salvaguarda': faixaSalvaguarda_descriptions ?? '',
                    'VUS': vus_descriptions ?? '',
                    'Adaptacao': selectedEstrategiaResult?.adaptacao ?? '',
                    'Retirada': selectedEstrategiaResult?.retirada ?? '',
                    'Defesa': selectedEstrategiaResult?.defesa ?? '',
                    'Defesa_adaptacao': selectedEstrategiaResult?.defesa_adaptacao ?? '',

                    formattedVus,
                    formattedAcoes,
                    formattedlstAnalise


                },
                img_mapa: "",//mapImage.replace("data:image/png;base64,", ""),
                objJsonToCreateImg: objToSendImgMapa,
                grafico_acoes: chartImageAcao,
                grafico_analise: chartImageAnalise,
                grafico_analise_cabecalho: ''
            });

            if (documentoBase64) {
                const link = document.createElement('a')
                link.href = 'data:application/octet-stream;base64,' + documentoBase64
                link.download = 'reporte_analise.pdf'
                link.style.display = 'none'
                document.body.appendChild(link)
                link.click()
                document.body.removeChild(link)
                postMessage({ type: 'hideLoader' }, '*')
            }
        } catch (error) {
            console.log({ error })
            postMessage({ type: 'errorMsg', value: { message: "Não foi possivel efetuar esta operação" } }, '*')

        } finally {
            postMessage({ type: 'hideLoader' }, '*')
        }
    }

    const optionsExportar = [
        {
            key: 'titulo',
            text: 'Exportar',
        },
        {
            key: 'exportarFichas',
            text: 'Fichas',
            disabled: !activeExportFicha
        }/*,
        {
            key: 'exportarResultados',
            text: 'Resultados',
        },*/
    ]


    const voltar = async () => {

        const iframe: any = document.getElementById('iframeGeoPortal')
        iframe.contentWindow?.postMessage({ type: 'SiarlCoordenadaBoxClose', value: 'true' }, '*')


        if (sessionStorage.getItem("novaAnaliseEstrategiaAdaptacao") == 'true' && !viewMode) {
            // setDeleteClicked(true);
            setOpenModalDescartar(true);
            return;
        }

        // (editMode ||
        if (SessionStorageService.getItem("isSubmitActionEstrategiaAdaptacao") == "true" || sessionStorage.getItem("analiseAntiga") == "true") {
            postMessage({ type: 'form', value: 'pesquisarEstrategiaAdaptacao' }, '*')
        }
        else if (!SessionStorageService.getItem("isSubmitActionEstrategiaAdaptacao")) {
            if (selectedEstrategiaResult?.id) {
                // const result = await deleteAnalise(selectedEstrategiaResult?.id)
                postMessage({ type: 'form', value: 'pesquisarEstrategiaAdaptacao' }, '*')
            }
            else {
                postMessage({ type: 'form', value: 'pesquisarEstrategiaAdaptacao' }, '*')
            }
        } else {
            postMessage({ type: 'form', value: 'pesquisarEstrategiaAdaptacao' }, '*')
        }

        setCoordenadasPoligono(undefined);
        setCoordenadasSelected(undefined);
        selectEstrategiaResultId(undefined)
        selectEstrategiaResult(undefined)
        setEaRegistoAnalise(undefined)

        iframe.contentWindow?.postMessage(
            { type: 'SiarlEaRegistoAnaliseClearLayers', value: "true" },
            '*'
        )

        iframe.contentWindow?.postMessage(
            { type: 'SiarlEaRegistoAnaliseSearch', value: undefined },
            '*'
        )

        iframe.contentWindow?.postMessage({ type: 'SiarlEaRegistoAnaliseClearLayers', value: "true" }, '*')

        iframe.contentWindow?.postMessage({ type: "SiarlRemoveSelection", value: 'true' }, '*')

        if (dataVusForm && dataVusForm.vus.length > 0) {
            iframe.contentWindow?.postMessage(
                { type: 'SiarlUsVusPoligonoClearLayers', value: "true" },
                '*'
            )
            iframe.contentWindow?.postMessage(
                { type: 'SiarlUsVusPontoClearLayers', value: "true" },
                '*'
            )
        }
        if (dataAcaoForm && dataAcaoForm.acoes.length > 0) {
            iframe.contentWindow?.postMessage(
                { type: 'SiarlIntAcaoClearLayers', value: "true" },
                '*'
            )
        }

        iframe.contentWindow?.postMessage(
            { type: 'SiarlRemoveSelection', value: "true" },
            '*'
        )
    }

    const cancelModalDescartar = () => {
        setOpenModalDescartar(false)
    }

    const [estadoFalse, setEstado] = useState(false)

    //
    const handleDescartar = async (e: any) => {
        const iframe: any = document.getElementById('iframeGeoPortal')
        iframe.contentWindow?.postMessage(
            {
                type: 'SiarlCoordenadaBoxClose',
                value: 'true',
            },
            '*'
        )
        iframe.contentWindow?.postMessage(
            {
                type: 'SiarlRemoveSelection',
                value: 'true',
            },
            '*'
        )

        iframe.contentWindow?.postMessage({ type: 'SiarlEaRegistoAnaliseClearLayers', value: "true" }, '*')

        iframe.contentWindow?.postMessage({ type: "SiarlRemoveSelection", value: 'true' }, '*')

        iframe.contentWindow?.postMessage({ type: 'SiarlEaRegistoAnaliseSearch', value: [-1] }, '*');

        iframe.contentWindow?.postMessage({ type: 'SiarlEaAnaliseAbrangenciaSearch', value: [-1] }, '*');

        setCoordenadasPoligono(undefined);
        setCoordenadasSelected(undefined);
        selectEstrategiaResultId(undefined);
        selectEstrategiaResult(undefined);
        setEaRegistoAnalise(undefined);

        setOpenModalDescartar(false);
        setDeleteClicked(false);

        const eaRegistoAnaliseSelected: any = getEaRegistoAnalise();

        const dataToSend: any = {
            id: eaRegistoAnaliseSelected?.id ?? undefined,
            status: estadoFalse
        }

        let AnaliseSaved: any
        if (eaRegistoAnaliseSelected?.id) {
            postMessage({ type: 'showLoader' }, '*')
            AnaliseSaved = await updateAnalise(dataToSend)
            selectEstrategiaResult({
                ...selectedEstrategiaResult,
                ...AnaliseSaved,
            })
            setEaRegistoAnalise(AnaliseSaved)
            postMessage({ type: 'hideLoader' }, '*')
        }

        SessionStorageService.removeItem("firstCallAnalise")
        postMessage({ type: 'form', value: 'pesquisarEstrategiaAdaptacao' }, '*')
    }

    /**
     * 
     * */
    const restartDataForms = () => {
        setDataVusForm((prevDataVusForm) => { return { updated: false, vus: [] } });
        setDataAcaoForm((prevDataAcaoForm) => { return { updated: false, anoReferencia: '----', acoes: [], acoesAtivas: [] } });

        if (selected > 1) {
            handleSelect({ selected: selected });
        }
    }

    // When any field is updated in the IdentificacaoForm form, verify that it is valid
    const changeIdentificacaoForm = () => {
        restartDataForms();
        setIsValidIdentificacaoForm(identificacaoFormRef.current?.isValid());
    };

    // When any field is updated in the ParametrosForm form, verify that it is valid
    const changeParametrosForm = () => {
        restartDataForms();
        setIsValidParametrosForm(parametrosFormRef.current?.isValid());
    };

    // When any field is updated in the VusForm form, verify that it is valid
    const changeVusForm = () => {
        setIsValidVusForm(vusFormRef.current?.isValid());
    };

    // When any field is updated in the AcaoForm form, verify that it is valid
    const changeAcaoForm = () => {
        setIsValidAcaoForm(acaoFormRef.current?.isValid());
    };

    /**
     * Check if the active tab form is valid to allow changing tabs
     * @param e
     * @param formRenderProps
     */

    const navigateToTab = async (tabIndex: number) => {
        const previousTab = selected;

        setSelected(tabIndex);
        setTabSelection(true);
        await new Promise((resolve) => setTimeout(resolve, 150));

        setSelected(previousTab);
        setTabSelection(true);
    };

    const captureChartFromTab = async (tabIndex: number, chartSelector: string) => {
        const previousTab = selected;

        setSelected(tabIndex);
        setTabSelection(true);
        await new Promise((resolve) => setTimeout(resolve, 500));

        const chartCanvas = document.querySelector(chartSelector) as HTMLCanvasElement;
        let chartImage;
        if (chartCanvas) {
            const generatedChartImage = await html2canvas(chartCanvas);
            chartImage = generatedChartImage.toDataURL();
        }

        setSelected(previousTab);
        setTabSelection(true);

        return chartImage;
    };

    const captureChartFromAnaliseTab = async () => {
        const previousTab = selected;

        setSelected(3);
        setTabSelection(true);
        await new Promise((resolve) => setTimeout(resolve, 500));

        const graficoAcaoCanvas = document.querySelector('#graficoAcao') as HTMLCanvasElement;
        let chartAcaoImage;
        if (graficoAcaoCanvas) {
            const generatedChartImage = await html2canvas(graficoAcaoCanvas);
            chartAcaoImage = generatedChartImage.toDataURL();
        }

        setSelected(previousTab);
        setTabSelection(true);

        return chartAcaoImage;
    };


    const handleSelect = async (e: TabStripSelectEventArguments) => {

        setRealizeNovaAnalise(false);
        let moveTab = false;

        if (e.selected < 2) {
            switch (selected) {
                case 0:
                    moveTab = identificacaoFormRef?.current?.isValid();
                    if (!moveTab) {
                        identificacaoFormRef?.current?.showInvalidMessage();
                    }
                    break;
                case 1:
                    moveTab = parametrosFormRef?.current?.isValid();
                    if (!moveTab) {
                        parametrosFormRef?.current?.showInvalidMessage();
                    }
                    break;
                default:
                    moveTab = true;
            }
        } else {
            moveTab = isValidConfigData(true);
        }

        if (moveTab) {
            setTabSelection(true);
            setSelected(e.selected);
        } else {
            setSelected(identificacaoFormRef?.current?.isValid() ? 1 : 0);
        }
    }

    /**
     * Verify that data was modified
     **/
    const isValidConfigData = (showMessage?: boolean) => {

        if (identificacaoFormRef.current && !identificacaoFormRef.current.isValid()) {
            if (showMessage) {
                identificacaoFormRef?.current?.showInvalidMessage();
            }
            return false;
        }

        if (parametrosFormRef.current && parametrosFormRef.current.isValid()) {
            return true;
        }

        if (parametrosFormRef.current && showMessage) {
            parametrosFormRef?.current?.showInvalidMessage();
        }

        return false;
    }

    /**
     * Verify that data was modified
     **/
    const isDirtyConfigData = () => {
        return identificacaoFormRef.current && identificacaoFormRef.current.isDirty() ? true : parametrosFormRef.current ? parametrosFormRef.current.isDirty() : false;
    }

    /**
     *
     * @param data
     */
    const getValoresUsoDoSolo = async (data: any) => await post<any, any>(GET_EA_VALOR_USO_DE_SOLO_BY_CUSTOM_FILTERS, data)

    /**
     *
     * @param data
     */
    const getAcoes = async (data: any) => await post<any, any>(`${CONSULTAR_EA_ACAO}`, data)

    const changeAcaoState = async (data: any) => await post<any, any>(`${EA_ACAO_CHANGE_STATE}`, data)

    /**
     *
     **/
    const loadVus = async (showMask = true) => {

        try {
            if (showMask)
                postMessage({ type: 'showLoader' }, '*')

            const formData = updateSendData();

            const dataToSend = {
                id_ea_registo_analise: formData.id ?? undefined,
                flatCoordinates: formData.flatCoordinates ?? undefined,
                atualizacaoDePreco: formData.atualizacao_preco ?? undefined,
                valor: formData.atualizacao_preco_valor ?? undefined,
                anoSelecionado: formData.atualizacao_preco_ano?.getFullYear() ?? undefined,
                ids_faixa_salva_guarda: formData.salvaguarda_faixa ?? undefined,
                ids_vus: formData.vus ?? undefined
            }

            const shouldSendData = Object.values(dataToSend).some((value) => value !== undefined);

            if (shouldSendData) {

                const resultadoValoresUsoDoSolo = await getValoresUsoDoSolo(dataToSend);

                setDataVusForm(createDataVusForm(resultadoValoresUsoDoSolo));

            } else {
                setDataVusForm(createDataVusForm({
                    resultadosPesquisa: [],
                    ano_referencia: null
                }));
            }
        } catch (error) {
            handleGenericError(error);
        }
        finally {
            if (showMask)
                postMessage({ type: 'hideLoader' }, '*')
        }
    }

    /**
     * 
     * @param searchResult
     */
    const createDataVusForm = (searchResult: any) => {

        const dataForm: DataVusForm = {
            updated: true,
            vus: searchResult?.resultadosPesquisa ?? [],
            anoReferencia: searchResult?.ano_referencia?.toString() ?? '----',
            valorTotalFS50Anos: searchResult?.valorTotalFS50Anos ?? 0,
            valorTotalFS100Anos: searchResult?.valorTotalFS100Anos ?? 0
        }

        const sendData = updateSendData()

        setDataAnaliseForm((prevDataAnaliseForm) => {
            return {
                ...prevDataAnaliseForm,
                ...{
                    updatedVus: true,
                    dataRelatorio: sendData?.data_hora_relatorio ?? "",
                    retirada: sendData["retirada"],
                    adaptacao: sendData["adaptacao"],
                    defesa: sendData["defesa"],
                    defesa_adaptacao: sendData["defesa_adaptacao"],
                    custo_adaptacao_edificio: +sendData["custo_adaptacao_edificio"],
                    custo_demolicao: +sendData["custo_demolicao"],
                    custo_renaturalizacao: +sendData["custo_renaturalizacao"],
                    cod_salvaguarda_faixa: sendData.cod_salvaguarda_faixa,
                    vus: dataForm?.vus ?? [],
                    valorTotalFS50Anos: dataForm?.valorTotalFS50Anos ?? 0,
                    valorTotalFS100Anos: dataForm?.valorTotalFS100Anos ?? 0
                }
            }
        });

        return dataForm;
    }

    /**
     * 
     **/
    const loadAcao = async (showMask = true) => {

        try {
            if (showMask)
                postMessage({ type: 'showLoader' }, '*')

            const formData = updateSendData();

            const dataToSend = {
                id_ea_registo_analise: formData.id,
                flatCoordinates: formData.flatCoordinatesApoio || formData.flatCoordinates ? (formData.flatCoordinatesApoio || formData.flatCoordinates) : undefined,
                de_data_con_e: formData.dt_periodo_analise_de ?? undefined,
                ate_data_con_e: formData.dt_periodo_analise_para ?? undefined,
                list_ids_tipo_n4: formData.lstTipologiasObra ?? undefined,
                atualizacaoDePreco: formData.atualizacao_preco ?? undefined,
                valor: formData.atualizacao_preco_valor ?? undefined,
                anoSelecionado: formData.atualizacao_preco_ano?.getFullYear() ?? undefined,
                isUsarIPC: true
            }

            if ((formData.defesa || formData.defesa_adaptacao) && dataToSend.flatCoordinates) {
                const results: any = await getAcoes(dataToSend);
                setDataAcaoForm(createDataAcaoForm(results));
            } else {
                setDataAcaoForm(createDataAcaoForm({
                    resultadosPesquisa: [],
                    ano_referencia: null
                }));
            }
        } catch (error) {
            postMessage({ type: 'errorMsg', value: { message: "Não foi possivel efetuar esta operação" } }, '*')
        } finally {
            if (showMask)
                postMessage({ type: 'hideLoader' }, '*')
        }
    }


    /**
     * Extract trend lines and cumulative values from a list of stocks
     * @param searchResult
     */
    const createDataAcaoForm = (searchResult: any) => {

        const listAcoes = searchResult?.resultadosPesquisa ?? [];

        const dataForm: DataAcoaForm = {
            updated: true,
            anoReferencia: searchResult?.ano_referencia?.toString() || '----',
            acoes: listAcoes,
            acoesAtivas: []
        }

        try {

            const acoesActivas = listAcoes?.filter((item: any) => item.analise_ativo && item.valor != undefined && item.valor != null && item.data_con_e).sort((acoe1: any, acoe2: any) => new Date(acoe1.data_con_e).getFullYear() - new Date(acoe2.data_con_e).getFullYear());

            if (acoesActivas.length > 0) {

                acoesActivas.forEach((element: any, index: number) => {
                    if (index == 0) {
                        element.valor_acumulado = element.valor;
                        element.valor_acumulado_me = element.valor / MILHAO_CONVERTER;
                    }
                    else if (element != null) {
                        element.valor_acumulado = acoesActivas[index - 1].valor_acumulado + element.valor;
                        element.valor_acumulado_me = element.valor_acumulado / MILHAO_CONVERTER;
                    }
                    element.valor_ano = element.data_con_e ? new Date(element.data_con_e).getFullYear() : null;
                })

                const xyAcumulados: { y: number; yRaw: number, x: number }[] = [];

                // get accumulated chart points
                acoesActivas?.map((o: { valor_acumulado: number, valor_acumulado_me: number, valor_ano: number }, index: number) => {
                    const yRaw = o.valor_acumulado;
                    const y = o.valor_acumulado_me;
                    const x = o.valor_ano;

                    if (y !== undefined && x !== null) {

                        const prev = xyAcumulados[xyAcumulados.length - 1]

                        if (prev && prev.x == x) {
                            prev.y = prev.y < y ? y : prev.y;
                            prev.yRaw = prev.yRaw < yRaw ? yRaw : prev.yRaw;
                        } else {
                            xyAcumulados.push({ y, yRaw, x });
                        }
                    }
                });

                xyAcumulados.sort((point1: any, point2: any) => point1.x - point2.x);

                dataForm.acoesAtivas = acoesActivas;
                dataForm.tendencia = calculateTrendLine(xyAcumulados);
                dataForm.tendenciaRaw = calculateTrendLine(xyAcumulados.map((point) => { return { x: point.x, y: point.yRaw } }));
                dataForm.xyAcumulados = xyAcumulados;
            }

            const sendData = updateSendData();

            setDataAnaliseForm((prevDataAnaliseForm) => {
                return {
                    ...prevDataAnaliseForm,
                    ...{
                        updatedAcao: true,
                        dataRelatorio: sendData?.data_hora_relatorio ?? "",
                        retirada: sendData["retirada"],
                        adaptacao: sendData["adaptacao"],
                        defesa: sendData["defesa"],
                        defesa_adaptacao: sendData["defesa_adaptacao"],
                        custo_adaptacao_edificio: +sendData["custo_adaptacao_edificio"],
                        custo_demolicao: +sendData["custo_demolicao"],
                        custo_renaturalizacao: +sendData["custo_renaturalizacao"],
                        cod_salvaguarda_faixa: sendData?.cod_salvaguarda_faixa ?? {},
                        anoReferencia: dataForm?.anoReferencia || '----',
                        acoesAtivas: dataForm?.acoesAtivas ?? [],
                        tendencia: dataForm?.tendencia,
                        tendenciaRaw: dataForm?.tendenciaRaw,
                        xyAcumulados: dataForm?.xyAcumulados ?? [],
                        valorTotalAcao: dataForm?.acoesAtivas.reduce((acc: any, acoe: { valor: any; }) => acc + acoe.valor, 0)
                    }
                }
            });

            return dataForm;
        }
        catch (ex) {
            console.log({ ex })

            return dataForm;
        }
    }

    /**
     * 
     * */
    const loadAnalise = async (nDataVusForm?: any, nDataAcaoForm?: any) => {

        postMessage({ type: 'showLoader' }, '*')

        const myDataVusForm = nDataVusForm ?? dataVusForm;
        const myDataAcaoForm = nDataAcaoForm ?? dataAcaoForm;

        try {
            if (!vusFormRef.current || !myDataVusForm || !myDataVusForm?.updated) {
                await loadVus(false);
            }
            postMessage({ type: 'showLoader' }, '*')
            if (!acaoFormRef.current || !myDataAcaoForm || !myDataAcaoForm?.updated) {
                await loadAcao(false);
            }
            postMessage({ type: 'showLoader' }, '*')
        } catch (e) {
            postMessage({ type: 'errorMsg', value: { message: "Não foi possivel efetuar esta operação" } }, '*')
        }
        finally {
            postMessage({ type: 'hideLoader' }, '*')
        }
    }


    /**
     * calculate trend line [calcular linha de tendência]
     * @param data
     */
    const calculateTrendLine = (data: { x: number; y: number }[]) => {

        const n = data.length;
        let slope = 0;
        let intercept = n > 0 ? data[0].y : 0;

        if (n > 1) {
            const sumX = data.reduce((acc, point) => acc + point.x, 0);
            const sumY = data.reduce((acc, point) => acc + point.y, 0);
            const sumXY = data.reduce((acc, point) => acc + point.x * point.y, 0);
            const sumX2 = data.reduce((acc, point) => acc + point.x * point.x, 0);

            slope = (n * sumXY - sumX * sumY) / (n * sumX2 - sumX * sumX); // inclinacao
            intercept = (sumY - slope * sumX) / n; // intercept
        }

        return { slope, intercept };
    };

    /**
     * Return send data object
     **/
    const updateSendData = () => {

        const identificacaoFormData: any = identificacaoFormRef.current?.getValues();
        const parameterFormData: any = parametrosFormRef.current?.getValues();
        const vusFormData: any = vusFormRef.current?.getValues();
        const acaoFormData: any = acoes;

        const eaRegistoAnaliseSelected: any = getEaRegistoAnalise();
        const userId = JSON.parse(localStorage.getItem(AUTH_LOCALSTORAGE) ?? '')
            ?.user?.id

        const dataToSend = {
            id: eaRegistoAnaliseSelected?.id ?? undefined,
            utilizador_id: userId,

            //TAB IDENTIFICACAO
            filedoc_cod: identificacaoFormData?.filedoc_cod ?? undefined,
            estado_id: identificacaoFormData?.estado_id?.id ?? undefined,
            data_registo: identificacaoFormData?.data_registo ?? undefined,
            entidade_id: identificacaoFormData?.entidade?.id ?? undefined,
            data_hora_relatorio: identificacaoFormData?.data_hora_relatorio ?? undefined,
            titulo: identificacaoFormData?.titulo ?? undefined,
            poligono_area_analise: identificacaoFormData?.poligono_area_analise ?? undefined,
            poligono_area_abrangencia_obras_execucao: identificacaoFormData?.poligono_area_abrangencia_obras_execucao ?? undefined,
            flatCoordinates: identificacaoFormData?.flatCoordinates ?? undefined,
            flatCoordinatesApoio: identificacaoFormData?.flatCoordinatesApoio ?? undefined,
            //Campos localização
            distrito_cod: identificacaoFormData?.distrito?.codigo ?? undefined,
            concelho_cod: identificacaoFormData?.concelho?.codigo ?? undefined,
            freguesia_cod: identificacaoFormData?.freguesia?.codigo ?? undefined,
            nuts1_cod: identificacaoFormData?.nuts1?.codigo ?? undefined,
            nuts2_cod: identificacaoFormData?.nuts2?.codigo ?? undefined,
            nuts3_cod: identificacaoFormData?.nuts3?.codigo ?? undefined,
            arh_id: identificacaoFormData?.arh?.codigo ?? undefined,

            //TAB PARAMETROS
            retirada: parameterFormData?.retirada ?? undefined,
            defesa: parameterFormData?.defesa ?? undefined,
            adaptacao: parameterFormData?.adaptacao ?? undefined,
            defesa_adaptacao: parameterFormData?.defesa_adaptacao ?? undefined,
            salvaguarda_faixa: parameterFormData?.salvaguarda_faixa ?? undefined,
            cod_salvaguarda_faixa: parameterFormData?.cod_salvaguarda_faixa ?? {},
            vus: parameterFormData?.vus ?? undefined,
            lstTipologiasObra: parameterFormData?.lstTipologiasObra?.map((tipologiaObra: { id: any; }) => tipologiaObra.id) ?? undefined,
            lstFinanciamento: parameterFormData?.lstFinanciamento ?? undefined,
            custo_adaptacao_edificio: parameterFormData?.custo_adaptacao_edificio ?? undefined,
            custo_demolicao: parameterFormData?.custo_demolicao ?? undefined,
            custo_renaturalizacao: parameterFormData?.custo_renaturalizacao ?? undefined,
            dt_periodo_analise_de: parameterFormData?.dt_periodo_analise_de ? new Date(parameterFormData?.dt_periodo_analise_de) : undefined,
            dt_periodo_analise_para: parameterFormData?.dt_periodo_analise_para ? new Date(parameterFormData?.dt_periodo_analise_para) : undefined,
            atualizacao_preco: parameterFormData?.atualizacao_preco ?? undefined,
            atualizacao_preco_valor: parameterFormData?.atualizacao_preco_valor ?? undefined,
            atualizacao_preco_ano: parameterFormData?.atualizacao_preco_ano ?? undefined,

            //TAB Vus
            vusData: vusFormData,

            //TAB Acao
            acaoData: acaoFormData,

            status: true
        }

        return dataToSend;
    }

    const refreshForm = async(id: any = undefined) => {

        let idAnalise = id;
        if (!idAnalise) {
          if (getEaRegistoAnalise()?.id) {
            idAnalise = getEaRegistoAnalise()?.id;
          } else {
            return;
          }
        }
        const analise = await getAnalise(idAnalise);

        const tecnico = await GetUserNameTecnico(analise.utilizador_id);
        const userId = JSON.parse(localStorage.getItem(AUTH_LOCALSTORAGE) ?? '')?.user?.id;

        const analiseObject = {
          ...analise,
          id: analise.id,
          nuts1: analise.nuts1 ?? undefined,
          nuts2: analise.nuts2 ?? undefined,
          nuts3: analise.nuts3 ?? undefined,
          distrito: analise.distrito ?? undefined,
          concelho: analise.mobilizacao ?? undefined,
          freguesia: analise.freguesia ?? undefined,
          arh: analise.arh ?? undefined,
          capitania: analise.capitania ?? undefined,
          massaagua: analise.massaagua ?? undefined,
          data_registo: analise.data_registo ? moment.utc(analise.data_registo).tz(CURRENT_TIMEZONE) : undefined,
          data_hora_relatorio: analise.data_hora_relatorio ? moment.utc(analise.data_hora_relatorio).tz(CURRENT_TIMEZONE) : undefined,
          dt_periodo_analise_de: analise.dt_periodo_analise_de ? moment.utc(analise.dt_periodo_analise_de).tz(CURRENT_TIMEZONE) : undefined,
          dt_periodo_analise_para: analise.dt_periodo_analise_para ? moment.utc(analise.dt_periodo_analise_para).tz(CURRENT_TIMEZONE) : undefined,
          atualizacao_preco: analise.atualizacao_preco ?? undefined,
          atualizacao_preco_valor: analise.atualizacao_preco_valor ?? undefined,
          atualizacao_preco_ano: analise?.atualizacao_preco_ano ? moment.utc(analise.atualizacao_preco_ano).tz(CURRENT_TIMEZONE) : undefined,
          filedoc_cod: analise?.filedoc_cod ?? undefined,
          estado_id: analise?.eaEstado ?? undefined,
          utilizador_id: userId,
          tecnicoRegisto: tecnico,
          entidade_id: analise?.entidade_id ?? undefined,
          titulo: analise?.titulo ?? undefined,
          poligono_area_analise: analise?.poligono_area_analise ?? undefined,
          poligono_area_abrangencia_obras_execucao: analise?.hasGeomAbrangencia ?? undefined,
          retirada: analise?.retirada ?? undefined,
          defesa: analise?.defesa ?? undefined,
          adaptacao: analise?.adaptacao ?? undefined,
          defesa_adaptacao: analise?.defesa_adaptacao ?? undefined,
          salvaguarda_faixa_i: analise?.salvaguarda_faixa_i ?? undefined,
          salvaguarda_faixa_ii: analise?.salvaguarda_faixa_ii ?? undefined,
          markrisk_edificios: analise?.markrisk_edificios ?? undefined,
          carta_ocupacao_solo: analise?.carta_ocupacao_solo ?? undefined,
          universidade_nova: analise?.universidade_nova ?? undefined,
          servicos_ecosistema: analise?.servicos_ecosistema ?? undefined,
          // lstTipologiasObra: preventPropsNullValues(analise?.lstTipologiasObra, "nome") ?? undefined,
          lstTipologiasObra: analise?.lstTipologiasObra ?? undefined,
          custo_adaptacao_edificio: analise?.custo_adaptacao_edificio ?? undefined,
          custo_demolicao: analise?.custo_demolicao ?? undefined,
          custo_renaturalizacao: analise?.custo_renaturalizacao ?? undefined,
          hasGeom: analise?.hasGeom
        }

        selectEstrategiaResult(analiseObject);
        setEaRegistoAnalise(analiseObject);

      }

    /**
     * Gets the data from the analysis log saved in the database
     * */
    const loadRegistoAnalise = async (errorMsg?: string) => {

        let ea_analise = null;

        // check if have id
        if (registoAnalise && registoAnalise?.id) {

            try {

                ea_analise = await getAnalise(registoAnalise?.id);

            } catch (error) {
                postMessage({ type: "errorMsg", value: errorMsg || "Não é possivel mostrar os dados neste momento" }, "*");
            } finally {
                setRegistoAnalise(ea_analise);
                restartDataForms();
                selectEstrategiaResultId(registoAnalise?.id);
                selectEstrategiaResult(ea_analise);
            }
        }
        return ea_analise;
    }

    /**
     * Import geometry
     * @param objToSend
     */
    const importGeo = async (objToSend: any) => {

        postMessage({ type: "showLoader" }, "*");

        if (!objToSend) {
            postMessage({ type: "errorMsg", value: "Não foi possivel salvar" }, "*");
            postMessage({ type: "hideLoader" }, "*");
            return;
        }

        let ea_analise;
        let ea_registo_analise_id;
        const eaRegistoAnalise = getEaRegistoAnalise();

        // check if you already have an id
        if (eaRegistoAnalise && eaRegistoAnalise?.id) {
            ea_analise = eaRegistoAnalise;
            ea_registo_analise_id = eaRegistoAnalise?.id;
        } else {
            const sendData = updateSendData();
            // save the analysis and get the id
            ea_analise = await saveAnalise(sendData);
            ea_registo_analise_id = ea_analise?.id;
            selectEstrategiaResult(ea_analise);
            setEaRegistoAnalise(ea_analise)
            selectEstrategiaResultId(ea_registo_analise_id);
            setRegistoAnalise(ea_analise);
        }
        try {
            objToSend = { ...objToSend, ea_registo_analise_id }
            // import geometry into analysis
            const result = activeImportGeom == "ImportGeomAbra" ? await importGeomAbraEaRegistoAnalise(objToSend) : await importGeomEaRegistoAnalise(objToSend)

            restartDataForms();
            setDataVusForm({ ...dataVusForm, ...{ updated: false, vus: [] } });
            setDataAcaoForm({ ...dataAcaoForm, ...{ updated: false, anoReferencia: '----', acoes: [], acoesAtivas: [] } });
            setActiveImportGeom(undefined);

            if (!result) {
                postMessage({ type: "errorMsg", value: "Não foi possivel salvar" }, "*");
                return;
            }

            try {
                // get data from analysis with new geometry
                await loadRegistoAnalise("Registo salvo mas, Não é possivel mostrar os dados neste momento").then((dataRegistoAnalise: any) => showGeomsRegistoAnalise(dataRegistoAnalise));

            } catch (error) {
                postMessage({ type: "errorMsg", value: "Registo salvo mas, Não é possivel mostrar os dados neste momento" }, "*");
            }
        } catch (err) {
            handleGenericError(err);
        } finally {
            setEaResultado(true);
            setOpenImportModal(false)

            postMessage({ type: "hideLoader" }, "*");
        }
    }

    /**
     * represents on the map the geometries of the analysis record
     * */
    const showGeomsRegistoAnalise = (dataRegistoAnalise?: any) => {

        const infoRegistoAnalise = dataRegistoAnalise ?? registoAnalise;

        const iframe: any = document.getElementById('iframeGeoPortal')

        iframe.contentWindow?.postMessage({ type: 'SiarlEaRegistoAnaliseClearLayers', value: "true" }, '*');
        iframe.contentWindow?.postMessage({ type: 'SiarlRemoveSelection', value: "true" }, '*');

        if (infoRegistoAnalise) {
            iframe.contentWindow?.postMessage({ type: 'SiarlEaRegistoAnaliseSearch', value: [infoRegistoAnalise.id] }, '*');

            if (infoRegistoAnalise.eaAbrangencia?.id) {
                iframe.contentWindow?.postMessage({ type: 'SiarlEaAnaliseAbrangenciaSearch', value: [infoRegistoAnalise.eaAbrangencia?.id] }, '*');
            }
        }
    }

    /**
     * close geometry import window
     * */
    const cancelImport = () => {
        setOpenImportModal(false)
    }

    /**
     * Submit form
     * @param e
     */
    const handleSubmit = async (e: any, clickSave?: boolean) => {

        try {

            postMessage({ type: "showLoader" }, "*");

            let saveData = !viewMode;

            if (clickSave) {
                switch (selected) {
                    case 0:
                        saveData = identificacaoFormRef?.current?.isValid();
                        if (!saveData) {
                            identificacaoFormRef?.current?.showInvalidMessage();
                        } else {
                            if (parametrosFormRef?.current) {
                                saveData = parametrosFormRef?.current?.isValid();
                                if (!saveData) {
                                    parametrosFormRef?.current?.showInvalidMessage();
                                    handleSelect({ selected: 2 })
                                }
                            } else {
                                saveData = false;
                                postMessage({ type: 'errorMsg', value: { message: "Verifique os campos obrigatórios." } }, '*');
                                handleSelect({ selected: 2 })
                            }
                        }
                        break;
                    case 1:
                        saveData = parametrosFormRef?.current?.isValid();
                        if (!saveData) {
                            parametrosFormRef?.current?.showInvalidMessage();
                        }
                        break;
                    default:
                        saveData = true;
                }
            }

            if (saveData) {

                const isSubmitAction: boolean = JSON.parse(SessionStorageService.getItem("isSubmitActionEstrategiaAdaptacao") ?? false);

                const dataToSend = updateSendData();

                let analiseSaved: any

                if (dataToSend?.id) {
                    analiseSaved = await updateAnalise(dataToSend)
                } else {
                    analiseSaved = await saveAnalise(dataToSend)
                    setRegistoAnalise(analiseSaved);
                }

                await refreshForm(analiseSaved?.id)

                if (clickSave && sessionStorage.getItem("novaAnaliseEstrategiaAdaptacao") == 'true') {
                    sessionStorage.setItem("novaAnaliseEstrategiaAdaptacao", 'false');
                    setViewMode(true);

                }

                if (!viewMode ) {
                    if (editMode) {
                        setViewMode(true)
                    }
                    postMessage({ type: 'sucessMsg' }, '*')
                }
            }
        } catch (error) {
            handleGenericError(error)
        } finally {
            postMessage({ type: "hideLoader" }, "*");
        }
    }

    /**
     * Move to next tab
     * @param e
     **/
    const handleNextTab = (e: any) => {
        e.preventDefault();
        if (selected < TOTAL_TABS) {
            handleSelect({ selected: selected + 1 });
        }
    }

    /**
     * Move to prev tab
     * @param e
     */
    const handlePrevTab = (e: any) => {
        e.preventDefault();
        if (selected > 0) {
            handleSelect({ selected: selected - 1 });
        }
    }


    const handleCancel = () => {
        postMessage({ type: "showLoader" }, "*");
        postMessage({ type: "form", value: "" }, "*");

        setTimeout(() => {
            postMessage({ type: "form", value: "novaAnaliseEstrategiaAdaptacao" }, "*");
            postMessage({ type: "hideLoader" }, "*");
        }, 10)
        // refreshForm()
    }

    const handleOpenModalDescartar = () => {
        if (
            sessionStorage.getItem('novaAnaliseEstrategiaAdaptacao') &&
            sessionStorage.getItem('novaAnaliseEstrategiaAdaptacao') == 'true'
        ) {
            setOpenModalDescartar(true);
        } else {
            onEditItemClick("SiarlVisualizar");
            handleCancel();
        }
    }


    /**
     * activate or deactivate the action
     * @param id_acao
     */
    const handleToggle = async (acaoData: any, value: boolean) => {

        postMessage({ type: 'showLoader' }, '*')

        try {

            const result = await changeAcaoState({
                id_analise: getEaRegistoAnalise()?.id,
                id_acao: acaoData.id_acao,
                value: value
            });

            if (result) {
                setDataAcaoForm((prevDataAcaoFrom) => {

                    const acoesUpdated = prevDataAcaoFrom.acoes.map((item: any) =>
                        item.id_acao === acaoData.id_acao ? { ...item, analise_ativo: value } : item
                    );

                    postMessage({ type: 'hideLoader' }, '*')

                    return createDataAcaoForm({
                        resultadosPesquisa: acoesUpdated,
                        ano_referencia: prevDataAcaoFrom.anoReferencia
                    });
                });
            }
        } catch (error) {
            handleGenericError(error);
        }
        finally {
            postMessage({ type: 'hideLoader' }, '*')
        }
    };

    const centeredHeaderCell: React.FC = (props: any) => {
        return (
            <div style={isMobile ? {} : {
                textAlign: 'center', fontWeight: 'bold', fontSize: '14px', color: '#001339', cursor: 'pointer'
            }}>
                {props.title}
            </div>
        );
    };


    const leftHeaderCell: React.FC = (props: any) => {
        return (
            <div style={isMobile ? {} : {
                textAlign: 'left', fontWeight: 'bold', fontSize: '14px', color: '#001339', cursor: 'pointer'
            }}>
                {props.title}
            </div>
        );
    };

    const [columnsAcoes, setColumnsAcoes] = useState<{ columns: { field: string, title: string, width: number | string, show: boolean, className?: string, headerCell?: any, cell?: any | string, footerCell?: any }[] }>({
        columns: [
            { field: "analise_ativo", title: "Ativo", show: true, width: 60, className: styles.eaGridColumnCenteredContent, headerCell: leftHeaderCell, cell: 'activeCell' },
            { field: "id_acao", title: "ID", show: true, width: 70 },
            { field: "designacao", title: "Designação", show: true, width: 220, footerCell: "anoAnalise" },
            { field: "tipo_n4.descricao", title: "Tipologia", show: true, width: 115, className: styles.eaGridColumnRightContent, footerCell: "total" },
            { field: "data_con_e", title: "Data de conclusão", show: true, width: 170, cell: 'dateCell' },
            { field: "taxa", title: "Taxa", show: true, width: 70, className: styles.eaGridColumnCenteredContent, headerCell: centeredHeaderCell },
            { field: "valor", title: "Valor atualizado", show: true, width: 155, className: styles.eaGridColumnRightContent, headerCell: centeredHeaderCell }
        ]
    })

    const [columnsVus, setColumnsVus] = useState<{ columns: { field: string, title: string, width: number | string, show: boolean, className?: string, headerCell?: any, footerCell?: any, cell?: any | string }[] }>({
        columns: [
            { field: "id_no_vus_table", title: "ID", show: true, width: 70 },
            { field: "usVus.descricao", title: "Vus", show: true, width: 240, footerCell: "B" },
            { field: "nivel_faixa", title: "Nivel faixa", show: true, width: 'auto', cell: 'nivelCell', className: isMobile ? "" : styles.eaGridColumnCenteredContent, headerCell: isMobile ? null : centeredHeaderCell, footerCell: "C" },
            { field: "ano_valor", title: "Ano", show: true, width: 'auto', className: isMobile ? "" : styles.eaGridColumnCenteredContent, headerCell: isMobile ? null : centeredHeaderCell, footerCell: "D" },
            { field: "taxa", title: "Taxa", show: true, width: 'auto', className: isMobile ? "" : styles.eaGridColumnCenteredContent, headerCell: isMobile ? null : centeredHeaderCell },
            { field: "valor", title: "Valor atualizado", show: true, width: 160, className: isMobile ? "" : styles.eaGridColumnRightContent, headerCell: isMobile ? null : centeredHeaderCell }
        ]
    })

    useLayoutEffect(() => {

        const handleResize = () => {

            if (window.innerWidth <= telaMobile) {
                setIsMobile(true);
                ocultaFloatingMenu_e_Mapa();

                setColumnsVus({
                    columns: [
                        { field: "id_no_vus_table", title: "ID", show: true, width: 100 },
                        { field: "usVus.descricao", title: "Vus", show: true, width: 300 },
                        { field: "nivel_faixa", title: "Nivel faixa", show: true, width: 'auto', cell: 'nivelCell' },
                        { field: "taxa", title: "Taxa", show: true, width: 'auto' },
                        { field: "valor", title: "Valor atualizado", show: true, width: 160 }
                    ]
                })

                setColumnsAcoes({
                    columns: [
                        { field: "analise_ativo", title: "Ativo", show: true, width: 60, cell: 'activeCell' },
                        { field: "id_acao", title: "ID", show: true, width: 80 },
                        { field: "designacao", title: "Designação", show: true, width: 240 },
                        { field: "tipo_n4.descricao", title: "Tipologia", show: true, width: 135 },
                        { field: "data_con_e", title: "Data", show: true, width: 90, cell: 'dateCell' },
                        { field: "taxa", title: "Taxa", show: true, width: 80 },
                        { field: "valor", title: "Valor atualizado", show: true, width: 155 }
                    ]
                })
            } else {
                setIsMobile(false);
                mostraFloatingMenu_e_Mapa();
            }
        };

        window.addEventListener('resize', handleResize);

        handleResize();

        return () => {
            window.removeEventListener('resize', handleResize);
        };

    }, []);

    const onItemClickMais = (event: any) => {

        elementoClickMais(event);

        onEditItemClick(event);
        onDropDowAreaItemClick(event);

        if (optionsExportar.some(option => option.key === event.item.key)) {
            onItemClickExportar(event);
        }
    };

    const optionsMais = [
        {
            key: 'titulo',
            text: 'Registo',
        },
        ...optionsEditar.map(option => ({
            ...option,
            className: 'icon-siarl icon-editar btnIconRegistar',
        })),
        {
            key: 'titulo',
            text: 'Opções',
        },
        {
            key: 'openFileDoc',
            text: 'Diretório de documentos',
            className: 'icon-siarl icon-filedoc btnIconRegistar'
        },
        {
            key: 'titulo',
            text: 'Área',
        },
        ...optionsArea.map(option => ({
            ...option,
            className: 'icon-siarl icon-area btnIconRegistar',
        })),
        {
            key: 'titulo',
            text: 'Imprimir',
        },
        {
            key: 'imprimirFicha',
            text: 'Fichas',
            className: 'icon-siarl icon-imprimir btnIconRegistar'
        },
        ...optionsExportar.map(option => ({
            ...option,
            className: 'icon-siarl icon-exportar btnIconRegistar',
        })),
    ]

    const handleAlteraTitulo = () => {
        setTituloAnalise(true);
    };

    const openAjuda = () => {
        window.open(URL_AJUDA_ESTRATEGIA_ADAPTACAO, "_blank")
    }

    return (
        <div className={styles.base}>
            <div className={styles.header}>
                <div>
                    <div className={styles.nomeDoModulo}>
                        Estratégia de adaptação
                    </div>
                    <div className={styles.tituloDaPagina}>
                        {!selectedEstrategiaResult || !selectedEstrategiaResult?.id ? 'Nova Análise' : (tituloAnalise ? 'Editar Análise' : 'Análise')}
                    </div>
                </div>
                <div>
                    {!isMobile && CanUpdateEA && (viewMode || editMode) && (sessionStorage.getItem("novaAnaliseEstrategiaAdaptacao") != 'true') ?
                        <DropDownButton
                            items={optionsEditar}
                            className={styles.btnEditar2}
                            iconClass="icon-siarl icon-editar"
                            onItemClick={onEditItemClick}
                            fillMode={'flat'}
                            itemRender={itemRender}
                            title="Editar"
                        ></DropDownButton>
                        : ''}

                    {!isMobile && (selected == 2 || selected == 3) &&
                        <VisualizadorColunas
                            setColumns={selected == 3 ? setColumnsAcoes : selected == 2 ? setColumnsVus : undefined}
                            columns={selected == 3 ? columnsAcoes : selected == 2 ? columnsVus : undefined}
                            styles={styles.btnEditar2}
                        />
                    }
                    <button className={styles.btnEditar2} onClick={onClickOpenFileDoc}
                        style={{ display: isMobile ? 'none' : '' }} id='openFileDoc'>
                        <span className="icon-siarl icon-filedoc"></span>
                    </button>

                    {!isMobile &&
                        <DropDownButton
                            items={optionsArea}
                            className={styles.btnEditar2}
                            iconClass="icon-siarl icon-area"
                            onItemClick={onDropDowAreaItemClick}
                            fillMode={'flat'}
                            itemRender={itemRender}
                            disabled={sessionStorage.getItem("novaAnaliseEstrategiaAdaptacao") != 'true' && !editMode}
                            title="Geometria - Área"
                        ></DropDownButton>
                    }

                    <button className={styles.btnEditar2}  onClick={onItemClickImprimir}
                        style={{ display: isMobile ? 'none' : '' }} id='imprimirFicha' title='Imprimir'>
                        <span className="icon-siarl icon-imprimir"></span>
                    </button>

                    <button className={styles.btnEditar2} onClick={onItemClickExportar}
                        style={{ display: isMobile ? 'none' : '' }} id='exportarFicha' title='Exportar ficha'>
                        <span className="icon-siarl icon-exportar"></span>
                    </button>

                    {isMobile &&
                        <DropDownButton
                            items={optionsMais}
                            className={styles.btnMais}
                            iconClass="icon-siarl icon-mais"
                            onItemClick={onItemClickMais}
                            fillMode={'flat'}
                            itemRender={itemRenderMais}
                            title="Mais Opções"
                        />
                    }

                    <button onClick={openAjuda} className={styles.btnInfo} title="Obter Ajuda">
                        <span className="icon-siarl icon-ajuda"></span>
                    </button>

                    <button className={styles.btnFechar} onClick={voltar} title="Fechar">
                        <span className="icon-siarl icon-fechar"></span>
                    </button>
                </div>

                {openImportModal ?
                    <ImportarGeometriaComponent onSubmit={importGeo} cancelImport={cancelImport} /> : <></>
                }

                {openRemoveAreaModal ? (
                    <Dialog
                        className={styles.dialogDesconformidades}
                        onClose={() => setOpenRemoveAreaModal(false)}
                    >
                        <Form
                            initialValues={{}}
                            render={(formRenderProps) => (
                                <FormElement style={{ maxWidth: 500 }}>
                                    <span className="textDescartar">Remover área </span>
                                    <br></br>
                                    <span>{'Tem a certeza que pretende remover a área selecionada?'}</span>
                                    <div className="k-form-buttons btnModal">
                                        <button
                                            type={'submit'}
                                            className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base capitalizeText btnWhite"
                                            onClick={() => {
                                                setRemoverAreaAbra(false);
                                                setOpenRemoveAreaModal(false);
                                            }}
                                        >Não</button>

                                        <button
                                            type={'submit'}
                                            className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary btnImportar capitalizeText"
                                            onClick={removeArea}
                                        >Sim</button>
                                    </div>
                                </FormElement>
                            )}
                        />
                    </Dialog>
                ) : (
                    <></>
                )}

                {openModalDescartar ? (
                    <Dialog
                        className={styles.dialogDesconformidades}
                        onClose={cancelModalDescartar}
                    >
                        <Form
                            initialValues={{}}
                            render={(formRenderProps) => (
                                <FormElement style={{ maxWidth: 500 }}>
                                    <fieldset>
                                        <span className="textDescartar">{deleteClicked ? 'Apagar' : 'Cancelar'} registo  </span>
                                        <br></br>
                                        <span>{deleteClicked ? 'Ao apagar este registo deixará de ter acesso, sendo necessária uma intervenção rigorosa para realizar a sua recuperação.' : 'Ao cancelar este registo irá perder os dados inseridos até ao momento.'}</span>
                                        <br></br>
                                        <span>{deleteClicked ? 'Tem a certeza que pretende apagar?' : 'Tem a certeza que pretende cancelar?'}</span>
                                    </fieldset>
                                    <div className="k-form-buttons btnModal">
                                        <button
                                            type={'submit'}
                                            className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base capitalizeText btnWhite"
                                            onClick={cancelModalDescartar}
                                        >
                                            Não
                                        </button>

                                        <button
                                            type={'submit'}
                                            className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary btnImportar capitalizeText"
                                            onClick={handleDescartar}
                                        >
                                            Sim
                                        </button>
                                    </div>
                                </FormElement>
                            )}
                        />
                    </Dialog>
                ) : (
                    <></>
                )}

            </div>
            <Form
                onSubmitClick={handleSubmit}
                render={(formRenderProps: FormRenderProps) => (
                    <>
                        <FormElement>
                            <TabStrip selected={selected} onSelect={(e) => { handleSelect(e) }} keepTabsMounted={true}
                                className={`${styles.innerStyleTabContent} ${viewMode ? 'tabsVisualizar' : ''}`}
                                scrollable={isMobile}>
                                <TabStripTab title="Identificação" key={"Identificação"}>
                                    <IdentificacaoEstrategiaAdaptacao
                                        ref={identificacaoFormRef}
                                        idForm={0}
                                        viewMode={viewMode}
                                        initialValuesForm={registoAnalise}
                                        disabled={disabledPolignoApoio}
                                        realizeNovaAnalise={realizeNovaAnalise}
                                        updateArea={updateArea}
                                        onChange={changeIdentificacaoForm}
                                        initialized={registerInitializeForm}
                                    />
                                </TabStripTab>
                                <TabStripTab title="Parâmetros" key={"Parâmetros"}>
                                    <EstrategiaAdaptacaoParametros
                                        ref={parametrosFormRef}
                                        viewMode={viewMode}
                                        idForm={1}
                                        initialValuesForm={registoAnalise}
                                        onChange={changeParametrosForm}
                                        initialized={registerInitializeForm}
                                    />
                                </TabStripTab>
                                <TabStripTab title="VUS" key={"VUS"}>
                                    <VusEstrategiaAdaptacao
                                        ref={vusFormRef}
                                        key={vusKey}
                                        idForm={2}
                                        isMobile={isMobile}
                                        initialValuesForm={dataVusForm}
                                        viewMode={viewMode}
                                        onChange={changeVusForm}
                                        colunasVisiveis={columnsVus}
                                        initialized={registerInitializeForm}
                                    />
                                </TabStripTab>
                                <TabStripTab title="Ações" key={"Ações"}>
                                    <AcaoEstrategiaAdaptacao
                                        ref={acaoFormRef}
                                        key={acaoKey}
                                        idForm={3}
                                        isMobile={isMobile}
                                        initialValuesForm={dataAcaoForm}
                                        viewMode={viewMode}
                                        onChange={changeAcaoForm}
                                        setActiveAcao={handleToggle}
                                        colunasVisiveis={columnsAcoes}
                                        initialized={registerInitializeForm}
                                    />
                                </TabStripTab>
                                <TabStripTab title="Análise" key={"Análise"}>
                                    <AnaliseEstrategiaAdaptacao
                                        idForm={4}
                                        key={analiseKey}
                                        initialValuesForm={dataAnaliseForm}
                                        viewMode={viewMode}
                                        isMobile={isMobile}
                                    />
                                </TabStripTab>
                                <TabStripTab title="Documentos" key={"Documentos"}>
                                    <DocumentoListagem pageName='estrategiaAdaptacao' viewMode={viewMode} formRenderProps={formRenderProps} idFormulario={'ea_registo_analise_id'} />
                                </TabStripTab>
                            </TabStrip>
                        </FormElement>

                        {(editMode || sessionStorage.getItem("novaAnaliseEstrategiaAdaptacao") == 'true')
                            && !viewMode ?
                            <div className={`${styles.footer} ${styles.justify_multiple_children}`}>
                                <div className={styles.botoesBrancosFooter}>
                                    <Button
                                        type="button"
                                        className={styles.btnSeguinte}
                                        onClick={handleOpenModalDescartar}
                                        title='Cancelar'
                                    >
                                        <span className="icon-siarl icon-fechar"></span>
                                        <span className={styles.rotulo}>
                                            {' '}&nbsp;{' '}
                                            Cancelar
                                        </span>
                                    </Button>
                                    <Button
                                        className={styles.btnAnterior}
                                        disabled={selected === 0}
                                        onClick={handlePrevTab}
                                        title='Anterior'
                                    >
                                        <span className="icon-siarl icon-anterior"></span>
                                        <span className={styles.rotulo}>
                                            {' '}&nbsp;{' '}
                                            Anterior
                                        </span>
                                    </Button>
                                    <Button
                                        className={styles.btnSeguinte}
                                        disabled={selected === TOTAL_TABS}
                                        onClick={handleNextTab}
                                        title='Seguinte'
                                    >
                                        <span className={styles.rotulo}>
                                            Seguinte
                                            {' '}&nbsp;{' '}
                                        </span>
                                        <span className="icon-siarl icon-seguinte"></span>
                                    </Button>
                                </div>

                                <Button
                                    type="button"
                                    className={styles.btnSubmeter}
                                    onClick={(e) => {
                                        handleSubmit(e, true);
                                    }}
                                    title={'Gravar'}
                                >
                                    <span className="icon-siarl icon-submeter btnIconRegistar"></span>
                                    <span className={styles.rotulo}>
                                        {' '}&nbsp;{' '}
                                        {'Gravar'}
                                    </span>
                                </Button>
                            </div>
                            : ''}
                    </>
                )}
            />
        </div>
    );
}